import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Stack,
  Chip,
  Avatar,
  IconButton,
  CircularProgress
} from '@mui/material';
import TwitterIcon from '@mui/icons-material/Twitter';
import LanguageIcon from '@mui/icons-material/Language';
import DiscordIcon from '@mui/icons-material/Forum';
import SearchById from '../components/SearchById';
import { personaNFTs } from '../data/persona';
import { rosenticaNFTs } from '../data/rosentica';
import { theplagueNFTs } from '../data/theplague';
import { sugartownNFTs } from '../data/sugartown';
import { khugaNFTs } from '../data/khuga';
import { v1punksNFTs } from '../data/v1-punks';
import { radrowebringNFTs } from '../data/radrowebring';
import { killabearsNFTs } from '../data/killabears';
import { theplooshiesNFTs } from '../data/theplooshies';
import { terraformsNFTs } from '../data/terraforms';
import { pixelladymakerNFTs } from '../data/pixelladymaker';
import { nakamigosNFTs } from '../data/nakamigos';
import { overworldincarnaNFTs } from '../data/overworldincarna';
import { moonbirdsNFTs } from '../data/moonbirds';
import { mypethooliganNFTs } from '../data/mypethooligan';
import { digidaigakuNFTs } from '../data/digidaigaku';
import { mushboomersNFTs } from '../data/mushboomers';
import { meebitsNFTs } from '../data/meebits';
import { embyNFTs } from '../data/emby';
import { reflectionsNFTs } from '../data/reflections';
import { piratenationNFTs } from '../data/piratenation';
import { metawinnersNFTs } from '../data/metawinners';
import { snackgangNFTs } from '../data/snackgang';
import { vvchecksNFTs } from '../data/vv-checks';
import { goblintownNFTs } from '../data/goblintown';
import { mfersNFTs } from '../data/mfers';
import { quirkiesNFTs } from '../data/quirkies';
import { cloneXNFTs } from '../data/cloneX';
import { DeGodsNFTs } from '../data/degods';
import { boredapekennelNFTs } from '../data/boredapekennel';
import { projectaeonNFTs } from '../data/projectaeon';
import { proofofnarnianNFTs } from '../data/proofofNarnian';
import { chimpersNFTs } from '../data/chimpers';
import { akidcalledbeastNFTs } from '../data/akidcalledbeast';
import { cyberkongzNFTs } from '../data/cyberkongz';
import { kanpaiinfinityNFTs } from '../data/kanpaiinfinity';
import { xpsrNFTs } from '../data/xpsr-24.js';
import { potatozNFTs } from '../data/potatoz.js';
import { bandbearsNFTs } from '../data/bandbears.js';
import { coolcatsNFTs } from '../data/cool-cats.js';
import { asyncNFTs } from '../data/async-blueprints.js';
import { opepenNFTs } from '../data/opepen-edition.js';
import { honeyCombNFTs } from '../data/honeycomb';
import { InfiniGodsNFTs } from '../data/infinigods';
import { CreepzbyOVERLORDNFTs } from '../data/CreepzbyOVERLORD';
import { cryptodickbuttsNFTs } from '../data/cryptodickbutts';
import { sprotoNFTs } from '../data/Sproto';
import { pandasNFTs } from '../data/kanpai-pandas';
import { sappysealsNFTs } from '../data/sappy-seals';
import { captainzNFTs } from '../data/the-captainz';
import { bitBearsNFTs } from '../data/bitbears';
import { mocaverseNFTs } from '../data/mocaverse';
import { remilioBabiesNFTs } from '../data/remilioBabies';
import { jirasanNfts } from '../data/jirasan';
import { boredApeYachtClubNfts } from '../data/boredApeYachtClub';
import { beanzNfts } from '../data/beanz';
import { trendingCollections, lilpudgysPrices } from '../data/collections';
import { mutantApeYachtClubNfts } from '../data/mutantApeYachtClub';
import { doodlesNfts } from '../data/doodles';
import Footer from '../components/Footer';
import PriceDisplay from '../components/common/PriceDisplay';
import { getRandomPudgyTokenIds, getPudgyPenguinImage } from '../utils/ipfs';

function CollectionPage() {
  const { collectionId } = useParams();
  const navigate = useNavigate();
  const [collection, setCollection] = useState(null);
  const [sampleNfts, setSampleNfts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadCollection = async () => {
      setLoading(true);
      const foundCollection = trendingCollections.find(c => c.id === collectionId);
      
      if (!foundCollection) {
        navigate('/404');
        return;
      }

      setCollection(foundCollection);

      if (collectionId === 'lil-pudgys') {
        const tokenIds = getRandomPudgyTokenIds(12);
        const nfts = tokenIds.map((tokenId, index) => ({
          id: tokenId,
          name: `Lil Pudgy #${tokenId}`,
          image: getPudgyPenguinImage(tokenId),
          price: lilpudgysPrices[index % lilpudgysPrices.length]
        }));
        setSampleNfts(nfts);
      } else if (collectionId === 'mutant-ape-yacht-club') {
        setSampleNfts(mutantApeYachtClubNfts);
      } else if (collectionId === 'doodles') {
        setSampleNfts(doodlesNfts);
      } else if (collectionId === 'pudgypenguins') {
        // Generate sample NFTs with real Pudgy Penguin images for the collection
        const getPriceForId = (id) => {
          // Map specific IDs to fixed prices between 17.1 and 22.5 ETH
          const priceMap = {
            8422: '17.10',
            6457: '17.45',
            5496: '17.85',
            6190: '18.20',
            623: '18.55',
            919: '18.90',
            3248: '19.25',
            3753: '19.65',
            8663: '20.10',
            7651: '20.45',
            7934: '20.80',
            1441: '21.15',
            1792: '21.50',
            3362: '21.85',
            3581: '22.20',
            7962: '22.50',
            2847: '17.15',
            4270: '17.55',
            8542: '17.95',
            5006: '18.35',
            205: '18.75',
            5149: '19.15',
            4759: '19.45',
            3365: '19.85',
            5015: '20.25',
            7480: '20.65',
            4510: '21.05',
            3314: '21.45',
            7070: '21.75',
            8394: '22.15',
            3463: '22.45'
          };
          return (priceMap[id] || '20.00') + ' ETH';
        };
        const existingPudgyPenguinsNfts = [
          { 
            id: 8422, 
            name: 'Pudgy Penguins #8422', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OiI1Pf5yCfrQWq3oAtAxN%252FRs6Ov%252Fv6ZYUMOmGzz36IAhrbE6viEJZNTMWewIGk1GOw%253D%253D.png', 
            price: getPriceForId(8422) 
          },
          { 
            id: 407, 
            name: 'Pudgy Penguins #407', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OjNOykfWkNOqlIlceNHCGTaHlbLdjXOtFYO0DA6dtYUwlwTafuIUha6QqdTegp22ag%253D%253D.png', 
            price: getPriceForId(407) 
          },
          { 
            id: 3758, 
            name: 'Pudgy Penguins #3758', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OiNPRgfUposvhjsNCzn1ZSBRToY6kP2hEWWTjiXgKuHxUswO1hprMpbH%252FE7mbyv%252FDg%253D%253D.png', 
            price: getPriceForId(3758) 
          },
          { 
            id: 495, 
            name: 'Pudgy Penguins #495', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OnoCbEdhOLawR7%252F%252FHTx9doUzpxCmA3gpr%252FS4uTgv7XCdZ3Zp00GoYu44TQv9GtgpUQ%253D%253D.png', 
            price: getPriceForId(495) 
          },
          { 
            id: 3934, 
            name: 'Pudgy Penguins #3934', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Ou0dm4ozORVWYf6SlSgGIqKJIK42tih27LCqPTsi5cl%252BEF62vIiDSJCY%252BJl9ZVZW4w%253D%253D.png', 
            price: getPriceForId(3934) 
          },
            
  {
    id: 6074,
    name: 'Pudgy Penguins #6074',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OiI1Pf5yCfrQWq3oAtAxN%252FRs6Ov%252Fv6ZYUMOmGzz36IAhrbE6viEJZNTMWewIGk1GOw%253D%253D.png',
    price: getPriceForId(6074)
  },
  {
    id: 4682,
    name: 'Pudgy Penguins #4682',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OiUIApGvbXDq8hy9gk%252FkTxBGwv0HO%252F%252BxRpCxtkKelx%252FffJNJZyeSIdX810ZrZ37xyA%253D%253D.png',
    price: getPriceForId(4682)
  },
  {
    id: 6692,
    name: 'Pudgy Penguins #6692',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OqPuNBrqXLWy%252Bz9RSoptMFpYyZVSOkKdfYTUaaGvrrqDJKXAC0QxsbYbQ3jtj%252FUxgw%253D%253D.png',
    price: getPriceForId(6692)
  },
  {
    id: 4134,
    name: 'Pudgy Penguins #4134',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OjNOykfWkNOqlIlceNHCGTaHlbLdjXOtFYO0DA6dtYUwlwTafuIUha6QqdTegp22ag%253D%253D.png',
    price: getPriceForId(4134)
  },
  {
    id: 5392,
    name: 'Pudgy Penguins #5392',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Om3mjJVqpVGEEUjlK5%252FR1KvfvtLFBW8tXr4QAiQ%252Buofl%252BQYkW0LRpnSVAXDMDQ18fw%253D%253D.png',
    price: getPriceForId(5392)
  },
  {
    id: 761,
    name: 'Pudgy Penguins #761',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Oor1PGcKpbSeU8WNxZd1m%252Fsnt6M0aTZkepflt%252BOMCRKcMsM9tFEK61OXheDqauuDBQ%253D%253D.png',
    price: getPriceForId(761)
  },
  {
    id: 1228,
    name: 'Pudgy Penguins #1228',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Oor1PGcKpbSeU8WNxZd1m%252Fsnt6M0aTZkepflt%252BOMCRKcMsM9tFEK61OXheDqauuDBQ%253D%253D.png',
    price: getPriceForId(1228)
  },
  {
    id: 7210,
    name: 'Pudgy Penguins #7210',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OsDy1UVHihQ94JOh10UWFbFnUkjl75HiGOh%252Bg%252BamQQmTK0Vgev5rLrdqzEcHtZq3cA%253D%253D.png',
    price: getPriceForId(7210)
  },
  {
    id: 4995,
    name: 'Pudgy Penguins #4995',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Ogt7DZcrvXq1xYmYHtpM13AoNkPmP1ses%252BJ6LopqkgzwnWiD0ldL3YuTXwHpX2g3%252FA%253D%253D.png',
    price: getPriceForId(4995)
  },
  {
    id: 8300,
    name: 'Pudgy Penguins #8300',
    image: 'https://img-cdn.magiceden.dev/rs:fill:800:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OoC1Im%252Fz70OiuhzRSz%252FLE%252Bs714oJ021hT%252FpKKicI2Lu0A1NACUHz%252B8EHIVNMPrBtKw%253D%253D.png',
    price: getPriceForId(8300)
  },
            
            
  {
    id: 1809,
    name: 'Pudgy Penguins #1809',
    image: 'https://img-cdn.magiceden.dev/rs:fill:800:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OpcNB%252FNIgR05Lk1oQZuyeuxI1yzY4UGFHWVLcfDI5tQTwPgENCP08m4hk2Nih2%252Fycw%253D%253D.png',
    price: getPriceForId(1809)
  },
  {
    id: 3627,
    name: 'Pudgy Penguins #3627',
    image: 'https://img-cdn.magiceden.dev/rs:fill:800:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OkV7Nb3C2fxknlgsZKSqGqpzL7%252BAZzZQyEiQBjfpQZxDHLfG%252BJjnm1SiEzDaAL72Lw%253D%253D.png',
    price: getPriceForId(3627)
  },
  {
    id: 6018,
    name: 'Pudgy Penguins #6018',
    image: 'https://img-cdn.magiceden.dev/rs:fill:800:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OlJZaiPbjUL3sOPHmFaql9ptSM46D813HjxeQwMoP1eG5VjbMQq48Ty3TZycWodobQ%253D%253D.png',
    price: getPriceForId(6018)
  },
  {
    id: 7219,
    name: 'Pudgy Penguins #7219',
    image: 'https://img-cdn.magiceden.dev/rs:fill:800:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OlPlElxOjjnyq33mc67jjp47xM4mkWHgxKnHegIWmY27Eq2qCNLYXY4FgUvDoYenaQ%253D%253D.png',
    price: getPriceForId(7219)
  },
  {
    id: 2485,
    name: 'Pudgy Penguins #2485',
    image: 'https://img-cdn.magiceden.dev/rs:fill:800:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Or92Lemn%252Fv6HylKmK%252FsGhGAUOrcFgZf1F4crgrhplyL3HxBOKPjkHrCTeUkPQnGW8g%253D%253D.png',
    price: getPriceForId(2485)
  },
  {
    id: 1234,
    name: 'Pudgy Penguins #1234',
    image: 'https://img-cdn.magiceden.dev/rs:fill:800:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OoZdpCTHL%252FIm18IdYnxWcSpJonRAj7DaT9%252Fm0BSkJ4GAvjw0oVqmCqEFAPLbb66uVQ%253D%253D.png',
    price: getPriceForId(1234)
  },
  {
    id: 4319,
    name: 'Pudgy Penguins #4319',
    image: 'https://img-cdn.magiceden.dev/rs:fill:800:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Okn3He2CzoRXJs7L95j%252BSumfxRe%252FoI7bayIk0kPMh84szGx2sCAV3RfUkI%252Bqo3zNBw%253D%253D.png',
    price: getPriceForId(4319)
  },
  {
    id: 8361,
    name: 'Pudgy Penguins #8361',
    image: 'https://img-cdn.magiceden.dev/rs:fill:800:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OozzbwPHKLuwf5vty%252FupOAVKnbUISjb8hbIn6hj4XnM7Og3t0wTBVx25ZbAdshqeHw%253D%253D.png',
    price: getPriceForId(8361)
  },
  {
    id: 5822,
    name: 'Pudgy Penguins #5822',
    image: 'https://img-cdn.magiceden.dev/rs:fill:800:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OuSjdVbSJVbmWqLg9YpZjYjM%252B8kDfYiVy8p9XUHKZwaX6ab%252BA2YI7IaMcnSLwHcwIQ%253D%253D.png',
    price: getPriceForId(5822)
  },
  {
    id: 7465,
    name: 'Pudgy Penguins #7465',
    image: 'https://img-cdn.magiceden.dev/rs:fill:800:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OlY1fgORAJL8ui4n08Cyle1%252BdjhjNMHl%252Fvk19kxeUS7PFUHlMhRTypLv3lKd7DHbcA%253D%253D.png',
    price: getPriceForId(7465)
  }
            
            
            
        ];
        // Add new Pudgy Penguins NFTs to the collection grid at a different location
        const newPudgyPenguinsNfts = [
          { 
            id: 222, 
            name: 'Pudgy Penguins #222', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OoK3A%252B1vSgwf88yp%252BeLnDqRKRhnhhbPOMe8HjIPYoL5rFNrA2EQMY%252B1GOz1S%252B%252BbKTw%253D%253D.png',
            price: getPriceForId(222)
          },
          { 
            id: 702, 
            name: 'Pudgy Penguins #702', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OjX80bG9LqhlFhgw%252FWMdyaAv3SzDapn19Va0ddAsVt4to7FR%252BkHq3ndVb2VVTMwMqg%253D%253D.png',
            price: getPriceForId(702)
          },
          { 
            id: 716, 
            name: 'Pudgy Penguins #716', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Ok0ZqCG6hL7BEJTVkimkM4AnUlun2I2FBMiT7xDuqqYnKLfoqYW2Ed1vd2lxOajLTw%253D%253D.png',
            price: getPriceForId(716)
          },
          { 
            id: 2640, 
            name: 'Pudgy Penguins #2640', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71On4Uu8RupEAOwyS2j9KKsArOJTm0sFRyu4x96YckNvtA9AAD6jx0yOta4uO%252BPHJ47g%253D%253D.png',
            price: getPriceForId(2640)
          },
          { 
            id: 7398, 
            name: 'Pudgy Penguins #7398', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Oj3yB4QxiFHq8u7xMWHcHjm2qhy%252F9ljIrKdpbIJTpF%252BOpMr0V4QF6tb013gt4mjsVw%253D%253D.png',
            price: getPriceForId(7398)
          },
          { 
            id: 7457, 
            name: 'Pudgy Penguins #7457', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OnrSZ4llkk9Brun7SjwG42RJWdlGOD%252Bfh5wnVbr1CfH2807JWzNmLFdBjnPIM%252F%252FvJg%253D%253D.png',
            price: getPriceForId(7457)
          },
          { 
            id: 1735, 
            name: 'Pudgy Penguins #1735', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OrsQX9y3RuYDV7rdfN7jnOFKooi17qiEfLH4A8ZMoQBdeLUJR%252FVgKi9vq%252FYRHlkkaA%253D%253D.png',
            price: getPriceForId(1735)
          },
        ];
        const moreNewPenguins = [
          { 
            id: 2378, 
            name: 'Pudgy Penguins #2378', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OjbtwZVm1sruv2L7yisoIWtu6KZHyb8p06UmpXmAmkchrimQ%252Fr%252FvM8FK6Pd0uPFivA%253D%253D.png',
            price: getPriceForId(2378)
          },
          { 
            id: 5332, 
            name: 'Pudgy Penguins #5332', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Oq8r9%252BmdtR6CnaZ8cKOT%252B5dS55o4YAMWOWKa9mwY3su%252FAFZRuNEryiarf5mAG%252Bubfg%253D%253D.png',
            price: getPriceForId(5332)
          },
          { 
            id: 5792, 
            name: 'Pudgy Penguins #5792', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OnI9sCcatonWW%252BQzQwVnuvUYdqDqWje73TqdO2sbzDy59lca1r5qcnrP6mNPi9CyAQ%253D%253D.png',
            price: getPriceForId(5792)
          },
          { 
            id: 5368, 
            name: 'Pudgy Penguins #5368', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Oo%252F1EswQoWnApV8ahqUE00Gpc3k%252FgQxBa30B84fvhwNVOxZOq1D2oa1zgMQgHQnKQA%253D%253D.png',
            price: getPriceForId(5368)
          },
          { 
            id: 2617, 
            name: 'Pudgy Penguins #2617', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OpHys919ieQ97htHQLWkBtpoow82pX8K3au6CKHZR502ebtmCj5gGnlBYTVCH4bouQ%253D%253D.png',
            price: getPriceForId(2617)
          },
          { 
            id: 4356, 
            name: 'Pudgy Penguins #4356', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OklfLBahPJlF5mY0BmDhOCJ5dsv1WZXmzxmU%252BSf513FqrUQmKzsCypqDpsVGqh%252BaUA%253D%253D.png',
            price: getPriceForId(4356)
          },
          { 
            id: 1630, 
            name: 'Pudgy Penguins #1630', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Oq5irz0yJJa0p0qszMvYOXLX4f%252BcMn7WZ3H2pGx%252B4%252Ftxm646vSsDfQ6if7CgeLq2xQ%253D%253D.png',
            price: getPriceForId(1630)
          }
        ];
        const evenMoreNewPenguins = [
          { 
            id: 6457, 
            name: 'Pudgy Penguins #6457', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Ol4viFMlwnI2g%252BifzWcC7PMkR9tob1U3Q1V5PT2YBLAZhsIqTLSb%252Fx8uUu7L1O6nHQ%253D%253D.png',
            price: getPriceForId(6457)
          },
          { 
            id: 5496, 
            name: 'Pudgy Penguins #5496', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OuPRnQk%252F9pLDNWmOtlrL4dDo3wBgTlvURbdfloxt3zAm%252FdEXOePeDU0%252FkimQXLhKXg%253D%253D.png',
            price: getPriceForId(5496)
          },
          { 
            id: 6190, 
            name: 'Pudgy Penguins #6190', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Om48zauV2Yy5geiHXDqqH3PZ4%252BTvoJ%252FKZ0B%252Bu4CFjRFyLhxh9Y%252BvVqo52C1QtmrU5A%253D%253D.png',
            price: getPriceForId(6190)
          },
          { 
            id: 623, 
            name: 'Pudgy Penguins #623', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OlkCM4gGnL2hqbR0d4h3gACqU5Befp7GcUMQs2NbvpnDOuj%252BumWExxcNfzAZ5sY70A%253D%253D.png',
            price: getPriceForId(623)
          },
          { 
            id: 919, 
            name: 'Pudgy Penguins #919', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Oou3mPC1mVVVG0SBTmUIqo4F3ryWpQR3tqcFMAdDVjRACGIkMDK0c23gr6m%252Ffxwfww%253D%253D.png',
            price: getPriceForId(919)
          }
        ];
        const finalNewPenguins = [
          { 
            id: 3248, 
            name: 'Pudgy Penguins #3248', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Ove6K5ag8Irjt5bne4iv7jyoSoMk8%252Bmjs8L8fDNB%252BFJzDoFv7rTbDMRZo4rq1pCQpQ%253D%253D.png',
            price: getPriceForId(3248)
          },
          { 
            id: 3753, 
            name: 'Pudgy Penguins #3753', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OgFwAAAl73ga8y8zIcfCdSYElPN8MOh6Ynu5mYRZzfegu%252BabM8GgVHs8t8Vet5f0WQ%253D%253D.png',
            price: getPriceForId(3753)
          },
          { 
            id: 8663, 
            name: 'Pudgy Penguins #8663', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OmRxNPedD1QIgX8B6%252F3bEJW19r8VgYiy5v3VhZGRsFL31%252BIS7dJTiGP9iaYQmVKS5w%253D%253D.png',
            price: getPriceForId(8663)
          },
          { 
            id: 7651, 
            name: 'Pudgy Penguins #7651', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OofMbzqGcIWPnh4Ph98N3zbAh0%252FFEN%252FDbrq1dD4hvEc%252BYJBMIrpjbMQiJThyK9IiKQ%253D%253D.png',
            price: getPriceForId(7651)
          },
          { 
            id: 7934, 
            name: 'Pudgy Penguins #7934', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Oq6ci5t%252FjYrFTghvv8nqwBk34dDUBJej%252F8kSkNnyFTRUEnCpycxEM0bJ4AplD59zEg%253D%253D.png',
            price: getPriceForId(7934)
          },
          { 
            id: 1441, 
            name: 'Pudgy Penguins #1441', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Oq5gELZBv5Er2zYF2bMZgXKyYaVWFn9%252Bum%252FF0G8YxSBqHse7HMAv28ZYcNr2mJxIzQ%253D%253D.png',
            price: getPriceForId(1441)
          },
          { 
            id: 1792, 
            name: 'Pudgy Penguins #1792', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OpScmR7jeKdehz15z4GtwMjP3A%252ByBhNzp2BJdMs7FGJKCVJXSBhZnYBE3o7VftDOQw%253D%253D.png',
            price: getPriceForId(1792)
          }
        ];
        const lastNewPenguins = [
          { id: 3362, name: 'Pudgy Penguins #3362', image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Ot1UA9CYxwDY6JES2yA5xFBlWZUZBWBbVgy7%252F%252B16vNPs77pwHqNIKrU7SP6KNeMU3A%253D%253D.png', price: getPriceForId(3362) },
          { id: 3581, name: 'Pudgy Penguins #3581', image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OrBMHSWpHngPosWiqsF4%252BVnfyxiQjjCij3eultM8I1tQVfGAMDt2ytAtw6cKXMc3Ew%253D%253D.png', price: getPriceForId(3581) },
          { id: 7962, name: 'Pudgy Penguins #7962', image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Or8Lq4k3sBcPKdnyAo6FGZej%252FFbeW670K8U36VLe4tGK1K1R3nRYKEjlOTsQYkuvbw%253D%253D.png', price: getPriceForId(7962) },
          { id: 2847, name: 'Pudgy Penguins #2847', image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Otk0btk5GbdxTeDXCsxiYG6gS7uVlHk2cLXByf9ogzYpOdMqUust9aPQjfBHnCUiYA%253D%253D.png', price: getPriceForId(2847) },
          { id: 4270, name: 'Pudgy Penguins #4270', image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Oszg6%252F8xRmCzkl24EoMuNsqt8IsQCNOwLvRt2t82A0Tu2FyWMnFVbU%252F6zve4VKZtYg%253D%253D.png', price: getPriceForId(4270) },
          { id: 8542, name: 'Pudgy Penguins #8542', image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Ojos%252FywnMLDFUcFPq4LUOILcyZcTEeaWuMHN0SgZNsX4Igpge%252F3gV7dahKtGtgRCfw%253D%253D.png', price: getPriceForId(8542) },
          { id: 5006, name: 'Pudgy Penguins #5006', image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Osagsk%252FvVMXFSS52dnqE%252FefFB4Df76Kgg9arW8tg241Wuj5ZUSFVnn6osOXuOtI1og%253D%253D.png', price: getPriceForId(5006) }
        ];
        const finalSetPenguins = [
          { 
            id: 205, 
            name: 'Pudgy Penguins #205', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OpiksY0SPNTN5fnGjt688hYDujsVWjn1dMZRFJpguL9zG86FgR6IU1nG9Td7TbiaKw%253D%253D.png',
            price: getPriceForId(205)
          },
          { 
            id: 5149, 
            name: 'Pudgy Penguins #5149', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OpnaKAHMmg8uEaCQ%252Fu5AGdriDBZY9R6W6xCTRQUxXXnHbTWONY%252B%252FVFG%252FSeTGCXNXBA%253D%253D.png',
            price: getPriceForId(5149)
          },
          { 
            id: 4759, 
            name: 'Pudgy Penguins #4759', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OnaSGYAmEz2s%252BCsZA%252FqnAPuPhrEDuHtLJW9ixjV8fH3zyOHipHMrqZT%252BnubS1p6fiw%253D%253D.png',
            price: getPriceForId(4759)
          },
          { 
            id: 3365, 
            name: 'Pudgy Penguins #3365', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Oq4u2KqKiMKtT2%252B5hEMuJ5ulEU0sjAbXXTnA5v8NPikn.png',
            price: getPriceForId(3365)
          },
          { 
            id: 5015, 
            name: 'Pudgy Penguins #5015', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OlMOP6EGSBPSW0Z1he%252F2eYGZ2ViUv1ubtRcmNJu52v5WtCEO787N%252Bm9SdI%252BXE9xZbg%253D%253D.png',
            price: getPriceForId(5015)
          },
          { 
            id: 7480, 
            name: 'Pudgy Penguins #7480', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OoZ7SZ%252FiDHU1icwbO3nMyDx%252Be5Olo%252FfFQR4L8aKt0pliRIXN9qc5Lv475XD6zEmIkQ%253D%253D.png',
            price: getPriceForId(7480)
          },
          { 
            id: 4510, 
            name: 'Pudgy Penguins #4510', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Osg1sN%252BguBQs0TLozwsPbCDhw9RGlVmW5MkXMyshNS6znXiN5lGkYywjzid0sXlc8w%253D%253D.png',
            price: getPriceForId(4510)
          },
          { 
            id: 3314, 
            name: 'Pudgy Penguins #3314', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OqzMLCKb%252BnxWukfcP1aivy0RAowbPlZdiyvoltfzaZK47X3CEDSUNt1bd9aGSndmxg%253D%253D.png',
            price: getPriceForId(3314)
          },
          { 
            id: 7070, 
            name: 'Pudgy Penguins #7070', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OiwVUw1QugZOlSJsr1HguFGGfbEpTvIEZ7DWuF0HIpxPWfDfVMAYdwkKrwpaMMmPkA%253D%253D.png',
            price: getPriceForId(7070)
          },
          { 
            id: 8394, 
            name: 'Pudgy Penguins #8394', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71OinOMgJFYubEC5XmQL%252BHTFGqLkVx%252BcGeVVbsPCfwVyxOjc%252B5wRbA5Xd%252FI6p8IEbRYg%253D%253D.png',
            price: getPriceForId(8394)
          },
          { 
            id: 3463, 
            name: 'Pudgy Penguins #3463', 
            image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvf2sE%252BcsbkeVl%252B4W8jWCuUkuov0PzHyR9IJ1xIZwBbFfEA%252Bwbk8y%252FqPIB7%252Bl8cd71Ol%252BSRNP6Q4Ng4QK18HMsje1Vv6EL1fKleSzt2wdgtcjn46Egsjwobrl6%252FyDUB9Jpsg%253D%253D.png',
            price: getPriceForId(3463)
          }
        ];
        const allPudgyPenguinsNfts = [...existingPudgyPenguinsNfts, ...newPudgyPenguinsNfts, ...moreNewPenguins, ...evenMoreNewPenguins, ...finalNewPenguins, ...lastNewPenguins, ...finalSetPenguins];
        // Sort NFTs by price before setting state
        setSampleNfts(allPudgyPenguinsNfts.sort((a, b) => parseFloat(a.price) - parseFloat(b.price)));
      } else if (collectionId === 'azuki') {
        // For Azuki collection, show specific NFTs with deterministic prices
        const getPriceForId = (id) => {
          const seed = parseInt(id);
          const random = ((seed * 9301 + 49297) % 233280) / 233280; // Simple PRNG
          return (random * 5 + foundCollection.floorPrice).toFixed(2) + ' ETH';
        };

        const azukiNfts = [
          { id: 8116, name: 'Azuki #8116', image: 'https://i.seadn.io/s/raw/files/d690b608a3693bc2c8987c91d52922bb.png?auto=format&dpr=1&w=640', price: getPriceForId(8116) },
          { id: 9286, name: 'Azuki #9286', image: 'https://i.seadn.io/s/raw/files/69b0ffe8b4227a305810ffb8a632d9a2.png?auto=format&dpr=1&w=640', price: getPriceForId(9286) },
          { id: 327, name: 'Azuki #327', image: 'https://i.seadn.io/s/raw/files/f8c597d61abed047c3e4e2c0dbcf3594.png?auto=format&dpr=1&w=640', price: getPriceForId(327) },
          { id: 1394, name: 'Azuki #1394', image: 'https://i.seadn.io/s/raw/files/a61e30c09621be8472590ffe081401f4.png?auto=format&dpr=1&w=640', price: getPriceForId(1394) },
          { id: 6798, name: 'Azuki #6798', image: 'https://i.seadn.io/s/raw/files/2525cc5c0946332f9e42a61640f766d3.png?auto=format&dpr=1&w=640', price: getPriceForId(6798) },
          { id: 8747, name: 'Azuki #8747', image: 'https://i.seadn.io/s/raw/files/14d7c47d24a7467aee48fb4d2bac11d9.png?auto=format&dpr=1&w=640', price: getPriceForId(8747) },
          { id: 3036, name: 'Azuki #3036', image: 'https://i.seadn.io/s/raw/files/1e44c22fe83691188304a4fcaf1093a6.png?auto=format&dpr=1&w=640', price: getPriceForId(3036) },
          { id: 1413, name: 'Azuki #1413', image: 'https://i.seadn.io/s/raw/files/c9b083b549a15aee5b5bf79fca80f710.png?auto=format&dpr=1&w=640', price: getPriceForId(1413) },
          { id: 1400, name: 'Azuki #1400', image: 'https://i.seadn.io/s/raw/files/3eaac906206cb7bacf851714d45762f9.png?auto=format&dpr=1&w=640', price: getPriceForId(1400) },
          { id: 3703, name: 'Azuki #3703', image: 'https://i.seadn.io/s/raw/files/ae57d8d41e7fe519c00f613fb38e4830.png?auto=format&dpr=1&w=640', price: getPriceForId(3703) },
          { id: 465, name: 'Azuki #465', image: 'https://i.seadn.io/s/raw/files/c5a670ebbe8081f8e42a046bdec1a230.png?auto=format&dpr=1&w=640', price: getPriceForId(465) },
            
             
    { id: 3574, name: 'Azuki #3574', image: 'https://i.seadn.io/s/raw/files/ed884b8031b22298d6b453bfa9e9cf02.png?auto=format&dpr=1&w=640', price: getPriceForId(3574) },
    { id: 4345, name: 'Azuki #4345', image: 'https://i.seadn.io/s/raw/files/72323815859cb5b717223bbc8025af77.png?auto=format&dpr=1&w=640', price: getPriceForId(4345) },
    { id: 3238, name: 'Azuki #3238', image: 'https://i.seadn.io/s/raw/files/c04b4956ba7b2746afaa851365144cc8.png?auto=format&dpr=1&w=640', price: getPriceForId(3238) },
    { id: 7814, name: 'Azuki #7814', image: 'https://i.seadn.io/s/raw/files/3d331c6d8f50c391e438dbba737275d4.png?auto=format&dpr=1&w=640', price: getPriceForId(7814) },
    { id: 7584, name: 'Azuki #7584', image: 'https://i.seadn.io/s/raw/files/61200e110093e565e6da900d04fca628.png?auto=format&dpr=1&w=640', price: getPriceForId(7584) },
    { id: 9915, name: 'Azuki #9915', image: 'https://i.seadn.io/s/raw/files/6e0b8baf258a72b5097f9cb5d40122c8.png?auto=format&dpr=1&w=640', price: getPriceForId(9915) },
    { id: 301, name: 'Azuki #301', image: 'https://i.seadn.io/s/raw/files/4e9635bd0dcfbb3222d8682991e1b0b0.png?auto=format&dpr=1&w=640', price: getPriceForId(301) },
    { id: 5442, name: 'Azuki #5442', image: 'https://i.seadn.io/s/raw/files/b7696b98d382d431231ec87752513c31.png?auto=format&dpr=1&w=640', price: getPriceForId(5442) },
    { id: 7102, name: 'Azuki #7102', image: 'https://i.seadn.io/s/raw/files/f7758ec34d559e46fa73664523cc8948.png?auto=format&dpr=1&w=640', price: getPriceForId(7102) },
    { id: 469, name: 'Azuki #469', image: 'https://i.seadn.io/s/raw/files/56f38736685804856dc34c382d3e8fe8.png?auto=format&dpr=1&w=640', price: getPriceForId(469) },
    { id: 1565, name: 'Azuki #1565', image: 'https://i.seadn.io/s/raw/files/6226311161ba8023b8ce9d3355d9a2e0.png?auto=format&dpr=1&w=640', price: getPriceForId(1565) },
    { id: 9960, name: 'Azuki #9960', image: 'https://i.seadn.io/s/raw/files/6b83b469fe5c0353a0e8c4e1ba60bf86.png?auto=format&dpr=1&w=640', price: getPriceForId(9960) },
    { id: 5181, name: 'Azuki #5181', image: 'https://i.seadn.io/s/raw/files/28418ad1a8056f798e38aae0c6b96f6a.png?auto=format&dpr=1&w=640', price: getPriceForId(5181) },
    { id: 8305, name: 'Azuki #8305', image: 'https://i.seadn.io/s/raw/files/591aab45dc3ef44c19ab49a83d4d0c60.png?auto=format&dpr=1&w=640', price: getPriceForId(8305) },
    { id: 6992, name: 'Azuki #6992', image: 'https://i.seadn.io/s/raw/files/41e691e3de4153f38c3c9a925cc4b36a.png?auto=format&dpr=1&w=640', price: getPriceForId(6992) },
    { id: 4466, name: 'Azuki #4466', image: 'https://i.seadn.io/s/raw/files/c91f283153aaeb008ba0fb4e7218edf8.png?auto=format&dpr=1&w=640', price: getPriceForId(4466) },
    { id: 2917, name: 'Azuki #2917', image: 'https://i.seadn.io/s/raw/files/6d876c0893c9a21ae2255a52aa123094.png?auto=format&dpr=1&w=640', price: getPriceForId(2917) },
    { id: 7857, name: 'Azuki #7857', image: 'https://i.seadn.io/s/raw/files/c99f3f082a69fe9db9983d5859a1dcc8.png?auto=format&dpr=1&w=640', price: getPriceForId(7857) },
    { id: 1051, name: 'Azuki #1051', image: 'https://i.seadn.io/s/raw/files/2e26a0d4ca77941dd687412400fe9e81.png?auto=format&dpr=1&w=640', price: getPriceForId(1051) },
    { id: 7644, name: 'Azuki #7644', image: 'https://i.seadn.io/s/raw/files/42daba97c6a9dace35f115f46d6444d7.png?auto=format&dpr=1&w=640', price: getPriceForId(7644) },
    { id: 2952, name: 'Azuki #2952', image: 'https://i.seadn.io/s/raw/files/fef752000cb4977efc1f6845f50e0294.png?auto=format&dpr=1&w=640', price: getPriceForId(2952) },
    { id: 6744, name: 'Azuki #6744', image: 'https://i.seadn.io/s/raw/files/87dfc2b06cafd095a4769dc67b6a6797.png?auto=format&dpr=1&w=640', price: getPriceForId(6744) },
    { id: 6107, name: 'Azuki #6107', image: 'https://i.seadn.io/s/raw/files/7ea6b2c743c742daec292bcc7d75c463.png?auto=format&dpr=1&w=640', price: getPriceForId(6107) },
    { id: 6996, name: 'Azuki #6996', image: 'https://i.seadn.io/s/raw/files/0f224605eae077d7336b0184a179b62c.png?auto=format&dpr=1&w=640', price: getPriceForId(6996) },
    { id: 5626, name: 'Azuki #5626', image: 'https://i.seadn.io/s/raw/files/e3c7ce94a0002aa45a45fc1ac142b07d.png?auto=format&dpr=1&w=640', price: getPriceForId(5626) },

            
            { id: 3723, name: 'Azuki #3723', image: 'https://i.seadn.io/s/raw/files/9ca519258ccb2032a266886bf4e5d8e1.png?auto=format&dpr=1&w=640', price: getPriceForId(3723) },
{ id: 1994, name: 'Azuki #1994', image: 'https://i.seadn.io/s/raw/files/88eae6e47b8e14481782ae3c0b11ef75.png?auto=format&dpr=1&w=640', price: getPriceForId(1994) },
{ id: 4185, name: 'Azuki #4185', image: 'https://i.seadn.io/s/raw/files/96de5d23f0a30dde80cbe8db6e2144ae.png?auto=format&dpr=1&w=640', price: getPriceForId(4185) },
{ id: 3440, name: 'Azuki #3440', image: 'https://i.seadn.io/s/raw/files/41adabd14690092f5488ab8cbeb294d5.png?auto=format&dpr=1&w=640', price: getPriceForId(3440) },
{ id: 331, name: 'Azuki #331', image: 'https://i.seadn.io/s/raw/files/54a9792e74313fe11772761b8c836afb.png?auto=format&dpr=1&w=640', price: getPriceForId(331) },
{ id: 7064, name: 'Azuki #7064', image: 'https://i.seadn.io/s/raw/files/fd1130ac64ffa39827d78c5d1f8dd7fd.png?auto=format&dpr=1&w=640', price: getPriceForId(7064) },
{ id: 5919, name: 'Azuki #5919', image: 'https://i.seadn.io/s/raw/files/0627c6c25a33f810add6499a9cafda63.png?auto=format&dpr=1&w=640', price: getPriceForId(5919) },
{ id: 6961, name: 'Azuki #6961', image: 'https://i.seadn.io/s/raw/files/4b56abee99d6bedd3183f1c7c04e96e6.png?auto=format&dpr=1&w=640', price: getPriceForId(6961) },
{ id: 3044, name: 'Azuki #3044', image: 'https://i.seadn.io/s/raw/files/6d0bacb5c4e525cf78a0c85cc9f7093f.png?auto=format&dpr=1&w=640', price: getPriceForId(3044) },
{ id: 1328, name: 'Azuki #1328', image: 'https://i.seadn.io/s/raw/files/e1bbfd6c74465d7d1283c5be208b399a.png?auto=format&dpr=1&w=640', price: getPriceForId(1328) },
{ id: 2705, name: 'Azuki #2705', image: 'https://i.seadn.io/s/raw/files/f5a65b8bcc3033ed50300f1979c956bb.png?auto=format&dpr=1&w=640', price: getPriceForId(2705) },
{ id: 9229, name: 'Azuki #9229', image: 'https://i.seadn.io/s/raw/files/41f85e728fe4eb204fa1577740cb8786.png?auto=format&dpr=1&w=640', price: getPriceForId(9229) },
{ id: 5630, name: 'Azuki #5630', image: 'https://i.seadn.io/s/raw/files/265989d6a5f8309e41a05323ec59b4cf.png?auto=format&dpr=1&w=640', price: getPriceForId(5630) },
{ id: 9006, name: 'Azuki #9006', image: 'https://i.seadn.io/s/raw/files/cd1e6423a3a7655e2a71c98ea9e70c38.png?auto=format&dpr=1&w=640', price: getPriceForId(9006) },
{ id: 6680, name: 'Azuki #6680', image: 'https://i.seadn.io/s/raw/files/3560e5cde52d1856abaef355d48fff1c.png?auto=format&dpr=1&w=640', price: getPriceForId(6680) },
{ id: 6048, name: 'Azuki #6048', image: 'https://i.seadn.io/s/raw/files/dc9ce6ed6c9fb7ce9c848a18104cf577.png?auto=format&dpr=1&w=640', price: getPriceForId(6048) },
{ id: 6045, name: 'Azuki #6045', image: 'https://i.seadn.io/s/raw/files/f1a20a30a665ba7746333f42ae18f69c.png?auto=format&dpr=1&w=640', price: getPriceForId(6045) },
{ id: 7920, name: 'Azuki #7920', image: 'https://i.seadn.io/s/raw/files/9ddf4260570c911535b3cf97f5295f73.png?auto=format&dpr=1&w=640', price: getPriceForId(7920) },
{ id: 2257, name: 'Azuki #2257', image: 'https://i.seadn.io/s/raw/files/085538b31b08df6f0ae29b97c8467ec0.png?auto=format&dpr=1&w=640', price: getPriceForId(2257) },
{ id: 1348, name: 'Azuki #1348', image: 'https://i.seadn.io/s/raw/files/15c56692fe749724469ad394672b1af1.png?auto=format&dpr=1&w=640', price: getPriceForId(1348) },

            { id: 8661, name: 'Azuki #8661', image: 'https://i.seadn.io/s/raw/files/3a8a30f022d3648ee0ce23ab2a9c73f8.png?auto=format&dpr=1&w=640', price: getPriceForId(8661) },
{ id: 6080, name: 'Azuki #6080', image: 'https://i.seadn.io/s/raw/files/d7948d0cfe90a5c923c65ff81975101a.png?auto=format&dpr=1&w=640', price: getPriceForId(6080) },
{ id: 989, name: 'Azuki #989', image: 'https://i.seadn.io/s/raw/files/926a70c48db754d60a2e1efeeab77b64.png?auto=format&dpr=1&w=640', price: getPriceForId(989) },
{ id: 9632, name: 'Azuki #9632', image: 'https://i.seadn.io/s/raw/files/268e3108e3ea8f32f9dba8a12b3ed547.png?auto=format&dpr=1&w=640', price: getPriceForId(9632) },
{ id: 1311, name: 'Azuki #1311', image: 'https://i.seadn.io/s/raw/files/37e20b5a6e865cc9303a6bf89ec655f3.png?auto=format&dpr=1&w=640', price: getPriceForId(1311) },
{ id: 7113, name: 'Azuki #7113', image: 'https://i.seadn.io/s/raw/files/5cc56dbe2e37f9598e4ca7a57696d9ef.png?auto=format&dpr=1&w=640', price: getPriceForId(7113) },
{ id: 6971, name: 'Azuki #6971', image: 'https://i.seadn.io/s/raw/files/22e291b59705693c87807b8de8b55ca1.png?auto=format&dpr=1&w=640', price: getPriceForId(6971) },
{ id: 6598, name: 'Azuki #6598', image: 'https://i.seadn.io/s/raw/files/2c202053c4f0be27a8078a8dd9137696.png?auto=format&dpr=1&w=640', price: getPriceForId(6598) },
{ id: 4934, name: 'Azuki #4934', image: 'https://i.seadn.io/s/raw/files/7d0894f2602e561fc0417804c10455fa.png?auto=format&dpr=1&w=640', price: getPriceForId(4934) },
{ id: 9197, name: 'Azuki #9197', image: 'https://i.seadn.io/s/raw/files/d161914291b721af2eb84592de7e4f1c.png?auto=format&dpr=1&w=640', price: getPriceForId(9197) },
{ id: 1520, name: 'Azuki #1520', image: 'https://i.seadn.io/s/raw/files/ddae8c9bfc92ad399007b9f5333fd5dd.png?auto=format&dpr=1&w=640', price: getPriceForId(1520) },
{ id: 8323, name: 'Azuki #8323', image: 'https://i.seadn.io/s/raw/files/73b5f46525f542712684f72fba4928c6.png?auto=format&dpr=1&w=640', price: getPriceForId(8323) },
{ id: 8127, name: 'Azuki #8127', image: 'https://i.seadn.io/s/raw/files/cb59845bb7fcf0c75fdb63ec059153c3.png?auto=format&dpr=1&w=640', price: getPriceForId(8127) },
{ id: 7238, name: 'Azuki #7238', image: 'https://i.seadn.io/s/raw/files/d3f2fb26e10ba896b770f9956cd3d9e8.png?auto=format&dpr=1&w=640', price: getPriceForId(7238) },
{ id: 7048, name: 'Azuki #7048', image: 'https://i.seadn.io/s/raw/files/cf76f9c142bd5bc00f6507072d2162e5.png?auto=format&dpr=1&w=640', price: getPriceForId(7048) },
{ id: 8824, name: 'Azuki #8824', image: 'https://i.seadn.io/s/raw/files/05284f714f3fa0364084e8be46df75e8.png?auto=format&dpr=1&w=640', price: getPriceForId(8824) },
{ id: 3151, name: 'Azuki #3151', image: 'https://i.seadn.io/s/raw/files/1b9e4c3cff85ac9c37a7f3434da4694c.png?auto=format&dpr=1&w=640', price: getPriceForId(3151) },
{ id: 3373, name: 'Azuki #3373', image: 'https://i.seadn.io/s/raw/files/58fa48150d6398eaacbb77f129c331c8.png?auto=format&dpr=1&w=640', price: getPriceForId(3373) },
{ id: 7148, name: 'Azuki #7148', image: 'https://i.seadn.io/s/raw/files/6f9cdbb6ef7e0333835ba8566f4285ee.png?auto=format&dpr=1&w=640', price: getPriceForId(7148) },
{ id: 3467, name: 'Azuki #3467', image: 'https://i.seadn.io/s/raw/files/fc65094c6edf1057f8ff631d26c92fcd.png?auto=format&dpr=1&w=640', price: getPriceForId(3467) },
{ id: 3376, name: 'Azuki #3376', image: 'https://i.seadn.io/s/raw/files/74f0df3a2d1db5e5881e76acb2ed3ebc.png?auto=format&dpr=1&w=640', price: getPriceForId(3376) },
{ id: 1796, name: 'Azuki #1796', image: 'https://i.seadn.io/s/raw/files/df03116ccad9ba11bd10814f92181359.png?auto=format&dpr=1&w=640', price: getPriceForId(1796) }

            
        ];
        setSampleNfts(azukiNfts.sort((a, b) => parseFloat(a.price) - parseFloat(b.price)));
      } else if (collectionId === 'azuki-elementals') {
        // For Azuki Elementals collection, show specific NFTs with deterministic prices
        const getPriceForId = (id) => {
          const seed = parseInt(id);
          const random = ((seed * 9301 + 49297) % 233280) / 233280; // Simple PRNG
          return (random * 2 + foundCollection.floorPrice).toFixed(2) + ' ETH';
        };
        const azukiElementalsNfts = [
          { id: 14706, name: 'Azuki Elementals #14706', image: 'https://elementals-images.azuki.com/013dda25-9504-4ff9-90fe-2dccf819d41a.png', price: getPriceForId(14706) },
          { id: 17069, name: 'Azuki Elementals #17069', image: 'https://elementals-images.azuki.com/15273654-466a-4bbb-94c0-5f368aaab56c.png', price: getPriceForId(17069) },
          { id: 2120, name: 'Azuki Elementals #2120', image: 'https://elementals-images.azuki.com/545b52e7-9801-4e28-ab7c-a0a33f2111cb.png', price: getPriceForId(2120) },
          { id: 16671, name: 'Azuki Elementals #16671', image: 'https://elementals-images.azuki.com/4bffa628-dd02-4a26-b628-4ff9941db174.png', price: getPriceForId(16671) },
            
  { id: 95, name: 'Azuki Elementals #95', image: 'https://elementals-images.azuki.com/8d8637da-632b-4ffa-8902-030286f77a53.png', price: getPriceForId(95) },
  { id: 16748, name: 'Azuki Elementals #16748', image: 'https://elementals-images.azuki.com/ffedc9c3-7fda-44ca-b04f-d30e0dce7ac5.png', price: getPriceForId(16748) },
  { id: 11407, name: 'Azuki Elementals #11407', image: 'https://elementals-images.azuki.com/0f02b2c7-4c5c-4916-961c-5860c5ebf57b.png', price: getPriceForId(11407) },
  { id: 7017, name: 'Azuki Elementals #7017', image: 'https://elementals-images.azuki.com/8ad73596-bb3b-4890-a233-bb3c6d1d69f8.png', price: getPriceForId(7017) },
  { id: 6484, name: 'Azuki Elementals #6484', image: 'https://elementals-images.azuki.com/0e3712fb-7e3a-41e8-afd1-ad8e355e2772.png', price: getPriceForId(6484) },
  { id: 9519, name: 'Azuki Elementals #9519', image: 'https://elementals-images.azuki.com/f884f221-c567-4675-bb2a-0fcf80783140.png', price: getPriceForId(9519) },
  { id: 9270, name: 'Azuki Elementals #9270', image: 'https://elementals-images.azuki.com/6807a4a7-731c-4544-9ef7-ce25ef866b38.png', price: getPriceForId(9270) },
  { id: 3838, name: 'Azuki Elementals #3838', image: 'https://elementals-images.azuki.com/0cb15a34-3af2-4338-ad19-985019629d34.png', price: getPriceForId(3838) },
  { id: 11644, name: 'Azuki Elementals #11644', image: 'https://elementals-images.azuki.com/5d57b1aa-d79e-4f9f-b0d5-2a3c68a685d3.png', price: getPriceForId(11644) },
  { id: 957, name: 'Azuki Elementals #957', image: 'https://elementals-images.azuki.com/f89d4127-bd68-4d0e-be06-771cfac8386f.png', price: getPriceForId(957) },
  { id: 19378, name: 'Azuki Elementals #19378', image: 'https://elementals-images.azuki.com/6cceea68-38a5-48da-9e5f-3560dfd1c115.png', price: getPriceForId(19378) },
  { id: 15690, name: 'Azuki Elementals #15690', image: 'https://elementals-images.azuki.com/d3dd34dc-40b5-4b39-a90c-74592bcd247f.png', price: getPriceForId(15690) },
  { id: 5797, name: 'Azuki Elementals #5797', image: 'https://elementals-images.azuki.com/1320fc68-4410-440f-92d2-2811ab143008.png', price: getPriceForId(5797) },
  { id: 11488, name: 'Azuki Elementals #11488', image: 'https://elementals-images.azuki.com/a7ce49a0-7cef-455a-a4a3-483bde990934.png', price: getPriceForId(11488) },
  { id: 8558, name: 'Azuki Elementals #8558', image: 'https://elementals-images.azuki.com/bdc93813-2744-4eee-8d30-8c3657284a7d.png', price: getPriceForId(8558) },
  { id: 17803, name: 'Azuki Elementals #17803', image: 'https://elementals-images.azuki.com/e1f40ba5-58f0-40ff-aaba-93fbf1643410.png', price: getPriceForId(17803) },
  { id: 4072, name: 'Azuki Elementals #4072', image: 'https://elementals-images.azuki.com/d95971f0-c70a-4b47-b296-b89a0090acb7.png', price: getPriceForId(4072) },
  { id: 4225, name: 'Azuki Elementals #4225', image: 'https://elementals-images.azuki.com/9d0ca596-c97b-4891-84b3-807a10f92750.png', price: getPriceForId(4225) },
  { id: 15306, name: 'Azuki Elementals #15306', image: 'https://elementals-images.azuki.com/bceca2b6-6462-4342-a012-30b4604a3002.png', price: getPriceForId(15306) },
  { id: 9839, name: 'Azuki Elementals #9839', image: 'https://elementals-images.azuki.com/fd0ce8af-71a6-4d1c-8b6b-5f9447eab15d.png', price: getPriceForId(9839) },
  { id: 19294, name: 'Azuki Elementals #19294', image: 'https://elementals-images.azuki.com/0304b973-266b-43cc-8e83-1e5523ffd9de.png', price: getPriceForId(19294) },
  { id: 19977, name: 'Azuki Elementals #19977', image: 'https://elementals-images.azuki.com/8082750f-515d-4ddf-b81f-98e2ddcd8b07.png', price: getPriceForId(19977) },
  { id: 7289, name: 'Azuki Elementals #7289', image: 'https://elementals-images.azuki.com/0622b45f-f7ea-4c80-884d-bf4fa13aff49.png', price: getPriceForId(7289) },
  { id: 16401, name: 'Azuki Elementals #16401', image: 'https://elementals-images.azuki.com/895f81f3-fb2b-4065-9c6f-2102cb6370de.png', price: getPriceForId(16401) },
  { id: 12745, name: 'Azuki Elementals #12745', image: 'https://elementals-images.azuki.com/073cc228-5a02-4297-82a2-324990a4a2ca.png', price: getPriceForId(12745) },
  { id: 8644, name: 'Azuki Elementals #8644', image: 'https://elementals-images.azuki.com/4cfb614d-0c44-45df-bd87-0d7ed0fe4836.png', price: getPriceForId(8644) },
  { id: 5676, name: 'Azuki Elementals #5676', image: 'https://elementals-images.azuki.com/5f456fb0-b7e7-42ed-b5f0-48f9d1e90b42.png', price: getPriceForId(5676) },
  { id: 11718, name: 'Azuki Elementals #11718', image: 'https://elementals-images.azuki.com/c3b3069e-0e29-4912-b677-43796c56a3b4.png', price: getPriceForId(11718) },
  { id: 16094, name: 'Azuki Elementals #16094', image: 'https://elementals-images.azuki.com/3ef290ed-afcd-4e44-a004-9273e6fb6ff6.png', price: getPriceForId(16094) },
  { id: 4714, name: 'Azuki Elementals #4714', image: 'https://elementals-images.azuki.com/647868ae-54e7-42c7-8b15-7d7b9b5be4d6.png', price: getPriceForId(4714) },
  { id: 12604, name: 'Azuki Elementals #12604', image: 'https://elementals-images.azuki.com/b5c37951-7d31-4c40-b671-3d05d47c6842.png', price: getPriceForId(12604) },
  { id: 16543, name: 'Azuki Elementals #16543', image: 'https://elementals-images.azuki.com/a4f32b10-c6d0-4aaf-9793-60d2c43db7ea.png', price: getPriceForId(16543) },
  { id: 7006, name: 'Azuki Elementals #7006', image: 'https://elementals-images.azuki.com/24fdb1a9-8c97-4720-a75d-7d452c34d2bf.png', price: getPriceForId(7006) },
  { id: 4705, name: 'Azuki Elementals #4705', image: 'https://elementals-images.azuki.com/f208543f-1be3-4e1a-86bd-ca78d4b6ae2f.png', price: getPriceForId(4705) },
  { id: 6417, name: 'Azuki Elementals #6417', image: 'https://elementals-images.azuki.com/ea13169f-15de-4e61-aa67-f8d5c3bcc4cc.png', price: getPriceForId(6417) },
  { id: 9535, name: 'Azuki Elementals #9535', image: 'https://elementals-images.azuki.com/e56621ed-2c5f-431b-a690-0c722a06050c.png', price: getPriceForId(9535) },
  { id: 320, name: 'Azuki Elementals #320', image: 'https://elementals-images.azuki.com/4922a76f-48b4-478d-a141-4a85bc96bd90.png', price: getPriceForId(320) },
  { id: 742, name: 'Azuki Elementals #742', image: 'https://elementals-images.azuki.com/de01f797-3587-446c-a3a7-915632b90edf.png', price: getPriceForId(742) },
  { id: 19449, name: 'Azuki Elementals #19449', image: 'https://elementals-images.azuki.com/633848ee-66a0-4819-93d7-a23bb6a7c2a3.png', price: getPriceForId(19449) },
  { id: 11322, name: 'Azuki Elementals #11322', image: 'https://elementals-images.azuki.com/84baa0bb-0154-4fa4-aefd-d86f7f917dc8.png', price: getPriceForId(11322) },
  { id: 16106, name: 'Azuki Elementals #16106', image: 'https://elementals-images.azuki.com/b57cca1f-5a6b-41c8-a960-17bcc0d1fa21.png', price: getPriceForId(16106) },
  { id: 15215, name: 'Azuki Elementals #15215', image: 'https://elementals-images.azuki.com/0bb61c68-d59f-4273-ae48-c2ab82ef5fce.png', price: getPriceForId(15215) },
  { id: 8918, name: 'Azuki Elementals #8918', image: 'https://elementals-images.azuki.com/678379ff-7b54-4d4c-a730-862d448d8516.png', price: getPriceForId(8918) },
  { id: 16946, name: 'Azuki Elementals #16946', image: 'https://elementals-images.azuki.com/c9394ab3-aa12-4df1-9d4d-e1c2b7c7518f.png', price: getPriceForId(16946) },
  { id: 16170, name: 'Azuki Elementals #16170', image: 'https://elementals-images.azuki.com/77529fdb-c9ff-47e1-a927-4e4ce5bb5ecc.png', price: getPriceForId(16170) },
  { id: 9379, name: 'Azuki Elementals #9379', image: 'https://elementals-images.azuki.com/212aaee9-c17b-4d4c-9f64-ebd54a3d7a76.png', price: getPriceForId(9379) },
  { id: 6459, name: 'Azuki Elementals #6459', image: 'https://elementals-images.azuki.com/dc001314-46ba-4942-af67-c01736b8c404.png', price: getPriceForId(6459) },
  { id: 17621, name: 'Azuki Elementals #17621', image: 'https://elementals-images.azuki.com/43fc1dff-8738-4a90-b131-ae1602e72e53.png', price: getPriceForId(17621) },
  { id: 6346, name: 'Azuki Elementals #6346', image: 'https://elementals-images.azuki.com/dcf00193-8777-42ec-9fa5-e3a0f7cf56fa.png', price: getPriceForId(6346) },
  { id: 5878, name: 'Azuki Elementals #5878', image: 'https://elementals-images.azuki.com/66cc917c-ef4b-4912-bb40-2a02c6defc88.png', price: getPriceForId(5878) },
  { id: 18373, name: 'Azuki Elementals #18373', image: 'https://elementals-images.azuki.com/f5a2f95a-8fc0-48c9-9de4-30fd39d49a4f.png', price: getPriceForId(18373) },
  { id: 9517, name: 'Azuki Elementals #9517', image: 'https://elementals-images.azuki.com/d59bfebf-fed6-4900-8037-5dbd2121b332.png', price: getPriceForId(9517) },
  { id: 15202, name: 'Azuki Elementals #15202', image: 'https://elementals-images.azuki.com/f149678e-046c-4590-85e4-42c949885a91.png', price: getPriceForId(15202) },
  { id: 13688, name: 'Azuki Elementals #13688', image: 'https://elementals-images.azuki.com/ec31dcab-dd7e-4549-87e9-853674b33097.png', price: getPriceForId(13688) },
  { id: 4615, name: 'Azuki Elementals #4615', image: 'https://elementals-images.azuki.com/6237bbb3-6c06-43be-865c-7865c630730b.png', price: getPriceForId(4615) },
  { id: 3751, name: 'Azuki Elementals #3751', image: 'https://elementals-images.azuki.com/7d263292-dd5f-4c09-9fce-67394448efa1.png', price: getPriceForId(3751) },
  { id: 15673, name: 'Azuki Elementals #15673', image: 'https://elementals-images.azuki.com/934bcf77-8c54-4218-b58f-fbe4b2ab350a.png', price: getPriceForId(15673) },
  { id: 6956, name: 'Azuki Elementals #6956', image: 'https://elementals-images.azuki.com/408e71d8-a3a4-4045-b4a3-431231dd332a.png', price: getPriceForId(6956) },
  { id: 19548, name: 'Azuki Elementals #19548', image: 'https://elementals-images.azuki.com/97ddf9d5-af38-454d-9b10-27bb190f6b1d.png', price: getPriceForId(19548) },
  { id: 13560, name: 'Azuki Elementals #13560', image: 'https://elementals-images.azuki.com/6895a108-30ad-4fb5-a800-e3e0b2ce75a3.png', price: getPriceForId(13560) },
  { id: 16219, name: 'Azuki Elementals #16219', image: 'https://elementals-images.azuki.com/dc881e6a-1d59-464f-a841-536dbe38a8da.png', price: getPriceForId(16219) }
        ];
        setSampleNfts(azukiElementalsNfts.sort((a, b) => parseFloat(a.price) - parseFloat(b.price)));
      } else if (collectionId === 'milady') {
        const getPriceForId = (id) => {
          return (Math.random() * 2 + 1.5).toFixed(2) + ' ETH';
        };

        const miladyNfts = [
          
          {
            id: 9998,
            name: 'Milady #9998',
            image: 'https://miladymaker.net/milady/9998.png',
            price: getPriceForId(9998)
          },
          {
            id: 9997,
            name: 'Milady #9997',
            image: 'https://miladymaker.net/milady/9997.png',
            price: getPriceForId(9997)
          },
            
            {
  id: 9995,
  name: 'Milady #9995',
  image: 'https://miladymaker.net/milady/9995.png',
  price: getPriceForId(9995)
},
{
  id: 9994,
  name: 'Milady #9994',
  image: 'https://miladymaker.net/milady/9994.png',
  price: getPriceForId(9994)
},
{
  id: 9993,
  name: 'Milady #9993',
  image: 'https://miladymaker.net/milady/9993.png',
  price: getPriceForId(9993)
},
{
  id: 9992,
  name: 'Milady #9992',
  image: 'https://miladymaker.net/milady/9992.png',
  price: getPriceForId(9992)
},
{
  id: 9991,
  name: 'Milady #9991',
  image: 'https://miladymaker.net/milady/9991.png',
  price: getPriceForId(9991)
},
{
  id: 9990,
  name: 'Milady #9990',
  image: 'https://miladymaker.net/milady/9990.png',
  price: getPriceForId(9990)
},
{
  id: 9989,
  name: 'Milady #9989',
  image: 'https://miladymaker.net/milady/9989.png',
  price: getPriceForId(9989)
},
{
  id: 9988,
  name: 'Milady #9988',
  image: 'https://miladymaker.net/milady/9988.png',
  price: getPriceForId(9988)
},
{
  id: 9987,
  name: 'Milady #9987',
  image: 'https://miladymaker.net/milady/9987.png',
  price: getPriceForId(9987)
},
{
  id: 9986,
  name: 'Milady #9986',
  image: 'https://miladymaker.net/milady/9986.png',
  price: getPriceForId(9986)
},
{
  id: 9984,
  name: 'Milady #9984',
  image: 'https://miladymaker.net/milady/9984.png',
  price: getPriceForId(9984)
},
{
  id: 9983,
  name: 'Milady #9983',
  image: 'https://miladymaker.net/milady/9983.png',
  price: getPriceForId(9983)
},
{
  id: 9982,
  name: 'Milady #9982',
  image: 'https://miladymaker.net/milady/9982.png',
  price: getPriceForId(9982)
},
{
  id: 9981,
  name: 'Milady #9981',
  image: 'https://miladymaker.net/milady/9981.png',
  price: getPriceForId(9981)
},
{
  id: 9980,
  name: 'Milady #9980',
  image: 'https://miladymaker.net/milady/9980.png',
  price: getPriceForId(9980)
},
{
  id: 9979,
  name: 'Milady #9979',
  image: 'https://miladymaker.net/milady/9979.png',
  price: getPriceForId(9979)
},
{
  id: 9978,
  name: 'Milady #9978',
  image: 'https://miladymaker.net/milady/9978.png',
  price: getPriceForId(9978)
},
{
  id: 9977,
  name: 'Milady #9977',
  image: 'https://miladymaker.net/milady/9977.png',
  price: getPriceForId(9977)
},
{
  id: 9972,
  name: 'Milady #9972',
  image: 'https://miladymaker.net/milady/9972.png',
  price: getPriceForId(9972)
},
{
  id: 9970,
  name: 'Milady #9970',
  image: 'https://miladymaker.net/milady/9970.png',
  price: getPriceForId(9970)
},
{
  id: 9974,
  name: 'Milady #9974',
  image: 'https://miladymaker.net/milady/9974.png',
  price: getPriceForId(9974)
},
{
  id: 9968,
  name: 'Milady #9968',
  image: 'https://miladymaker.net/milady/9968.png',
  price: getPriceForId(9968)
},
{
  id: 9976,
  name: 'Milady #9976',
  image: 'https://miladymaker.net/milady/9976.png',
  price: getPriceForId(9976)
},
{
  id: 9966,
  name: 'Milady #9966',
  image: 'https://miladymaker.net/milady/9966.png',
  price: getPriceForId(9966)
},
{
  id: 9971,
  name: 'Milady #9971',
  image: 'https://miladymaker.net/milady/9971.png',
  price: getPriceForId(9971)
},
{
  id: 9973,
  name: 'Milady #9973',
  image: 'https://miladymaker.net/milady/9973.png',
  price: getPriceForId(9973)
},
{
  id: 9975,
  name: 'Milady #9975',
  image: 'https://miladymaker.net/milady/9975.png',
  price: getPriceForId(9975)
},
{
  id: 9969,
  name: 'Milady #9969',
  image: 'https://miladymaker.net/milady/9969.png',
  price: getPriceForId(9969)
},
{
  id: 9965,
  name: 'Milady #9965',
  image: 'https://miladymaker.net/milady/9965.png',
  price: getPriceForId(9965)
},
{
  id: 9967,
  name: 'Milady #9967',
  image: 'https://miladymaker.net/milady/9967.png',
  price: getPriceForId(9967)
},
{
  id: 9964,
  name: 'Milady #9964',
  image: 'https://miladymaker.net/milady/9964.png',
  price: getPriceForId(9964)
},
{
  id: 9963,
  name: 'Milady #9963',
  image: 'https://miladymaker.net/milady/9963.png',
  price: getPriceForId(9963)
},
{
  id: 9962,
  name: 'Milady #9962',
  image: 'https://miladymaker.net/milady/9962.png',
  price: getPriceForId(9962)
},
{
  id: 9961,
  name: 'Milady #9961',
  image: 'https://miladymaker.net/milady/9961.png',
  price: getPriceForId(9961)
},
{
  id: 9960,
  name: 'Milady #9960',
  image: 'https://miladymaker.net/milady/9960.png',
  price: getPriceForId(9960)
},
{
  id: 9959,
  name: 'Milady #9959',
  image: 'https://miladymaker.net/milady/9959.png',
  price: getPriceForId(9959)
},
{
  id: 9958,
  name: 'Milady #9958',
  image: 'https://miladymaker.net/milady/9958.png',
  price: getPriceForId(9958)
},
{
  id: 9957,
  name: 'Milady #9957',
  image: 'https://miladymaker.net/milady/9957.png',
  price: getPriceForId(9957)
},
{
  id: 9956,
  name: 'Milady #9956',
  image: 'https://miladymaker.net/milady/9956.png',
  price: getPriceForId(9956)
},
{
  id: 9955,
  name: 'Milady #9955',
  image: 'https://miladymaker.net/milady/9955.png',
  price: getPriceForId(9955)
},
{
  id: 9946,
  name: 'Milady #9946',
  image: 'https://miladymaker.net/milady/9946.png',
  price: getPriceForId(9946)
},
{
  id: 9938,
  name: 'Milady #9938',
  image: 'https://miladymaker.net/milady/9938.png',
  price: getPriceForId(9938)
},
{
  id: 9954,
  name: 'Milady #9954',
  image: 'https://miladymaker.net/milady/9954.png',
  price: getPriceForId(9954)
},
{
  id: 9945,
  name: 'Milady #9945',
  image: 'https://miladymaker.net/milady/9945.png',
  price: getPriceForId(9945)
},
{
  id: 9937,
  name: 'Milady #9937',
  image: 'https://miladymaker.net/milady/9937.png',
  price: getPriceForId(9937)
},
{
  id: 9953,
  name: 'Milady #9953',
  image: 'https://miladymaker.net/milady/9953.png',
  price: getPriceForId(9953)
},
{
  id: 9948,
  name: 'Milady #9948',
  image: 'https://miladymaker.net/milady/9948.png',
  price: getPriceForId(9948)
},
{
  id: 9942,
  name: 'Milady #9942',
  image: 'https://miladymaker.net/milady/9942.png',
  price: getPriceForId(9942)
},
{
  id: 9950,
  name: 'Milady #9950',
  image: 'https://miladymaker.net/milady/9950.png',
  price: getPriceForId(9950)
},
{
  id: 9944,
  name: 'Milady #9944',
  image: 'https://miladymaker.net/milady/9944.png',
  price: getPriceForId(9944)
},
{
  id: 9952,
  name: 'Milady #9952',
  image: 'https://miladymaker.net/milady/9952.png',
  price: getPriceForId(9952)
},
{
  id: 9940,
  name: 'Milady #9940',
  image: 'https://miladymaker.net/milady/9940.png',
  price: getPriceForId(9940)
},
{
  id: 9941,
  name: 'Milady #9941',
  image: 'https://miladymaker.net/milady/9941.png',
  price: getPriceForId(9941)
},
{
  id: 9949,
  name: 'Milady #9949',
  image: 'https://miladymaker.net/milady/9949.png',
  price: getPriceForId(9949)
},
{
  id: 9943,
  name: 'Milady #9943',
  image: 'https://miladymaker.net/milady/9943.png',
  price: getPriceForId(9943)
},
{
  id: 9951,
  name: 'Milady #9951',
  image: 'https://miladymaker.net/milady/9951.png',
  price: getPriceForId(9951)
},
{
  id: 9947,
  name: 'Milady #9947',
  image: 'https://miladymaker.net/milady/9947.png',
  price: getPriceForId(9947)
},
{
  id: 9939,
  name: 'Milady #9939',
  image: 'https://miladymaker.net/milady/9939.png',
  price: getPriceForId(9939)
},
{
  id: 9936,
  name: 'Milady #9936',
  image: 'https://miladymaker.net/milady/9936.png',
  price: getPriceForId(9936)
},
{
  id: 9935,
  name: 'Milady #9935',
  image: 'https://miladymaker.net/milady/9935.png',
  price: getPriceForId(9935)
},
{
  id: 9934,
  name: 'Milady #9934',
  image: 'https://miladymaker.net/milady/9934.png',
  price: getPriceForId(9934)
},
{
  id: 9933,
  name: 'Milady #9933',
  image: 'https://miladymaker.net/milady/9933.png',
  price: getPriceForId(9933)
},
{
  id: 9932,
  name: 'Milady #9932',
  image: 'https://miladymaker.net/milady/9932.png',
  price: getPriceForId(9932)
},
{
  id: 9931,
  name: 'Milady #9931',
  image: 'https://miladymaker.net/milady/9931.png',
  price: getPriceForId(9931)
},
{
  id: 9930,
  name: 'Milady #9930',
  image: 'https://miladymaker.net/milady/9930.png',
  price: getPriceForId(9930)
},
{
  id: 9929,
  name: 'Milady #9929',
  image: 'https://miladymaker.net/milady/9929.png',
  price: getPriceForId(9929)
},
{
  id: 9928,
  name: 'Milady #9928',
  image: 'https://miladymaker.net/milady/9928.png',
  price: getPriceForId(9928)
},
{
  id: 9927,
  name: 'Milady #9927',
  image: 'https://miladymaker.net/milady/9927.png',
  price: getPriceForId(9927)
},
{
  id: 9926,
  name: 'Milady #9926',
  image: 'https://miladymaker.net/milady/9926.png',
  price: getPriceForId(9926)
},
{
  id: 9925,
  name: 'Milady #9925',
  image: 'https://miladymaker.net/milady/9925.png',
  price: getPriceForId(9925)
},
{
  id: 9922,
  name: 'Milady #9922',
  image: 'https://miladymaker.net/milady/9922.png',
  price: getPriceForId(9922)
},
{
  id: 9924,
  name: 'Milady #9924',
  image: 'https://miladymaker.net/milady/9924.png',
  price: getPriceForId(9924)
},
{
  id: 9921,
  name: 'Milady #9921',
  image: 'https://miladymaker.net/milady/9921.png',
  price: getPriceForId(9921)
},
{
  id: 9923,
  name: 'Milady #9923',
  image: 'https://miladymaker.net/milady/9923.png',
  price: getPriceForId(9923)
},
{
  id: 9918,
  name: 'Milady #9918',
  image: 'https://miladymaker.net/milady/9918.png',
  price: getPriceForId(9918)
},
{
  id: 9914,
  name: 'Milady #9914',
  image: 'https://miladymaker.net/milady/9914.png',
  price: getPriceForId(9914)
},
{
  id: 9912,
  name: 'Milady #9912',
  image: 'https://miladymaker.net/milady/9912.png',
  price: getPriceForId(9912)
},
{
  id: 9920,
  name: 'Milady #9920',
  image: 'https://miladymaker.net/milady/9920.png',
  price: getPriceForId(9920)
},
{
  id: 9916,
  name: 'Milady #9916',
  image: 'https://miladymaker.net/milady/9916.png',
  price: getPriceForId(9916)
},
{
  id: 9911,
  name: 'Milady #9911',
  image: 'https://miladymaker.net/milady/9911.png',
  price: getPriceForId(9911)
},
{
  id: 9913,
  name: 'Milady #9913',
  image: 'https://miladymaker.net/milady/9913.png',
  price: getPriceForId(9913)
},
{
  id: 9919,
  name: 'Milady #9919',
  image: 'https://miladymaker.net/milady/9919.png',
  price: getPriceForId(9919)
},
{
  id: 9915,
  name: 'Milady #9915',
  image: 'https://miladymaker.net/milady/9915.png',
  price: getPriceForId(9915)
},
{
  id: 9910,
  name: 'Milady #9910',
  image: 'https://miladymaker.net/milady/9910.png',
  price: getPriceForId(9910)
},
{
  id: 9909,
  name: 'Milady #9909',
  image: 'https://miladymaker.net/milady/9909.png',
  price: getPriceForId(9909)
},
{
  id: 9908,
  name: 'Milady #9908',
  image: 'https://miladymaker.net/milady/9908.png',
  price: getPriceForId(9908)
},
{
  id: 9906,
  name: 'Milady #9906',
  image: 'https://miladymaker.net/milady/9906.png',
  price: getPriceForId(9906)
},
{
  id: 9907,
  name: 'Milady #9907',
  image: 'https://miladymaker.net/milady/9907.png',
  price: getPriceForId(9907)
},
{
  id: 9905,
  name: 'Milady #9905',
  image: 'https://miladymaker.net/milady/9905.png',
  price: getPriceForId(9905)
},
{
  id: 9904,
  name: 'Milady #9904',
  image: 'https://miladymaker.net/milady/9904.png',
  price: getPriceForId(9904)
},
{
  id: 9903,
  name: 'Milady #9903',
  image: 'https://miladymaker.net/milady/9903.png',
  price: getPriceForId(9903)
},
{
  id: 9902,
  name: 'Milady #9902',
  image: 'https://miladymaker.net/milady/9902.png',
  price: getPriceForId(9902)
},
{
  id: 9900,
  name: 'Milady #9900',
  image: 'https://miladymaker.net/milady/9900.png',
  price: getPriceForId(9900)
},
{
  id: 9894,
  name: 'Milady #9894',
  image: 'https://miladymaker.net/milady/9894.png',
  price: getPriceForId(9894)
},
{
  id: 9901,
  name: 'Milady #9901',
  image: 'https://miladymaker.net/milady/9901.png',
  price: getPriceForId(9901)
},
{
  id: 9898,
  name: 'Milady #9898',
  image: 'https://miladymaker.net/milady/9898.png',
  price: getPriceForId(9898)
},
            
          {
            id: 9996,
            name: 'Milady #9996',
            image: 'https://miladymaker.net/milady/9996.png',
            price: getPriceForId(9996)
          }
        ];

        setSampleNfts(miladyNfts);
      } else if (collectionId === 'lilpudgys') {
        // For LilPudgys collection, use fixed prices from the price map
        const getPrice = (id) => {
          return (lilpudgysPrices[id] || '1.75') + ' ETH';
        };
        const lilPudgyNfts = [
          { id: 730, name: 'LilPudgys #730', image: 'https://i.seadn.io/gcs/files/5fe365d489e084030729eba2cc632ded.png?auto=format&dpr=1&w=384', price: getPrice(730) },
          { id: 15097, name: 'LilPudgys #15097', image: 'https://i.seadn.io/gcs/files/a0f89aa997992b75036f7f1511da5b17.png?auto=format&dpr=1&w=384', price: getPrice(15097) },
          { id: 1768, name: 'LilPudgys #1768', image: 'https://i.seadn.io/gcs/files/b2ab8abc178043df6f6e36b5f4bd3ca6.png?auto=format&dpr=1&w=384', price: getPrice(1768) },
          { id: 16733, name: 'LilPudgys #16733', image: 'https://i.seadn.io/gcs/files/e7432828862b39c17a42231e17b97186.png?auto=format&dpr=1&w=384', price: getPrice(16733) },
          { id: 942, name: 'LilPudgys #942', image: 'https://i.seadn.io/s/raw/files/aa5b6ed177274c24698bf3e6fc80c9eb.png?auto=format&dpr=1&w=384', price: getPrice(942) },
          { id: 2679, name: 'LilPudgys #2679', image: 'https://i.seadn.io/gcs/files/42baf33a7a31f9f5b37b2693c1cda2a7.png?auto=format&dpr=1&w=384', price: getPrice(2679) },
          { id: 1593, name: 'LilPudgys #1593', image: 'https://i.seadn.io/gcs/files/37852cb5d4c0a75114b242605e66fde0.png?auto=format&dpr=1&w=384', price: getPrice(1593) },
          { id: 15901, name: 'LilPudgys #15901', image: 'https://i.seadn.io/gcs/files/568dd4310cde56d9a67b2e7bd0b78060.png?auto=format&dpr=1&w=384', price: getPrice(15901) },
          { id: 12211, name: 'LilPudgys #12211', image: 'https://i.seadn.io/gcs/files/417bc92f240f298eca2fc580fd16087e.png?auto=format&dpr=1&w=384', price: getPrice(12211) },
          { id: 22083, name: 'LilPudgys #22083', image: 'https://i.seadn.io/gcs/files/3cc41ea1461c578734d4f4caad0480c9.png?auto=format&dpr=1&w=384', price: getPrice(22083) },
          { id: 3840, name: 'LilPudgys #3840', image: 'https://i.seadn.io/gcs/files/be26d5e3257ea172f18607406971d416.png?auto=format&dpr=1&w=384', price: getPrice(3840) },
          { id: 18766, name: 'LilPudgys #18766', image: 'https://i.seadn.io/gcs/files/361d0b0dcd1e199b1f44174a2aaeb25a.png?auto=format&dpr=1&w=384', price: getPrice(18766) },
          { id: 17286, name: 'LilPudgys #17286', image: 'https://i.seadn.io/gcs/files/266afacecb64939f0217a9c8b529a5d7.png?auto=format&dpr=1&w=1000', price: getPrice(17286) },
          { id: 17122, name: 'LilPudgys #17122', image: 'https://i.seadn.io/gcs/files/31067d622e725bd7d52bf12acced0788.png?auto=format&dpr=1&w=384', price: getPrice(17122) },
          { id: 11860, name: 'LilPudgys #11860', image: 'https://i.seadn.io/gcs/files/f0978cde39fad36b401b1215f8742028.png?auto=format&dpr=1&w=384', price: getPrice(11860) },
          { id: 4517, name: 'LilPudgys #4517', image: 'https://i.seadn.io/gcs/files/c48d549c26605e3f3ad0500ee03589ca.png?auto=format&dpr=1&w=384', price: getPrice(4517) },
          { id: 14163, name: 'LilPudgys #14163', image: 'https://i.seadn.io/gcs/files/416ad81de008f62b01aae5fd33a2b91e.png?auto=format&dpr=1&w=384', price: getPrice(14163) },
          { id: 14165, name: 'LilPudgys #14165', image: 'https://i.seadn.io/gcs/files/f879c553362f9ddb72c989000cf82e75.png?auto=format&dpr=1&w=384', price: getPrice(14165) },
          { id: 12227, name: 'LilPudgys #12227', image: 'https://i.seadn.io/gcs/files/40b9e90659645a9ec7c5e726c40b64a9.png?auto=format&dpr=1&w=384', price: getPrice(12227) },
          { id: 6494, name: 'LilPudgys #6494', image: 'https://i.seadn.io/gcs/files/646fa61dcd128c1e853c4337fdd099f7.png?auto=format&dpr=1&w=384', price: getPrice(6494) },
          { id: 7664, name: 'LilPudgys #7664', image: 'https://i.seadn.io/gcs/files/14997055dcb410d12ab0488fa7fddef8.png?auto=format&dpr=1&w=384', price: getPrice(7664) },
          { id: 4823, name: 'LilPudgys #4823', image: 'https://i.seadn.io/gcs/files/e731a2904aecce18933cb994375c7444.png?auto=format&dpr=1&w=384', price: getPrice(4823) },
          { id: 3618, name: 'LilPudgys #3618', image: 'https://i.seadn.io/gcs/files/a2d7f3ab8cc5d759dfaeb64e1c7a11ce.png?auto=format&dpr=1&w=384', price: getPrice(3618) },
          { id: 17100, name: 'LilPudgys #17100', image: 'https://i.seadn.io/gcs/files/9713f39b9163bdc898b7cdf48cda2ea9.png?auto=format&dpr=1&w=384', price: getPrice(17100) },
          { id: 21308, name: 'LilPudgys #21308', image: 'https://i.seadn.io/gcs/files/45603eef3867f5d5c1268c883a700e67.png?auto=format&dpr=1&w=384', price: getPrice(21308) },
          { id: 12809, name: 'LilPudgys #12809', image: 'https://i.seadn.io/gcs/files/cb0f654facc91dc28caac49c3427176e.png?auto=format&dpr=1&w=384', price: getPrice(12809) },
          { id: 10759, name: 'LilPudgys #10759', image: 'https://i.seadn.io/gcs/files/95d0b893d343f3867bf1ed8d5b8abf8f.png?auto=format&dpr=1&w=384', price: getPrice(10759) },
          { id: 13570, name: 'LilPudgys #13570', image: 'https://i.seadn.io/gcs/files/ac3d64887d557b3b2e0dd2579a0411ca.png?auto=format&dpr=1&w=384', price: getPrice(13570) },
          { id: 2655, name: 'LilPudgys #2655', image: 'https://i.seadn.io/gcs/files/688e8ee889dc3b02835b37f89b073118.png?auto=format&dpr=1&w=384', price: getPrice(2655) },
          { id: 17806, name: 'LilPudgys #17806', image: 'https://i.seadn.io/gcs/files/7959637d8beddc4328dd0779ad8a9922.png?auto=format&dpr=1&w=384', price: getPrice(17806) },
          { id: 4249, name: 'LilPudgys #4249', image: 'https://i.seadn.io/gcs/files/fe660570ef743ceea6a01c2c7e11dce1.png?auto=format&dpr=1&w=384', price: getPrice(4249) },
          { id: 6232, name: 'LilPudgys #6232', image: 'https://i.seadn.io/gcs/files/1241b439eb9a3d7d80af0c3e0a440e7c.png?auto=format&dpr=1&w=384', price: getPrice(6232) },
          { id: 5046, name: 'LilPudgys #5046', image: 'https://i.seadn.io/s/raw/files/3e185be386a8fee00db2f56090fde18b.png?auto=format&dpr=1&w=384', price: getPrice(5046) },
          { id: 19430, name: 'LilPudgys #19430', image: 'https://i.seadn.io/gcs/files/3cc41ea1461c578734d4f4caad0480f7.png?auto=format&dpr=1&w=384', price: getPrice(19430) },
          { id: 4126, name: 'LilPudgys #4126', image: 'https://i.seadn.io/gcs/files/085d73fa8db577e8c4d7c6dd44e774c0.png?auto=format&dpr=1&w=384', price: getPrice(4126) },
          { id: 15833, name: 'LilPudgys #15833', image: 'https://i.seadn.io/gcs/files/deed8ff91c01f718187f7c0752beb56a.png?auto=format&dpr=1&w=384', price: getPrice(15833) },
          { id: 1184, name: 'LilPudgys #1184', image: 'https://i.seadn.io/gcs/files/fb7f71509d0605c39956330505067870.png?auto=format&dpr=1&w=384', price: getPrice(1184) },
          { id: 10705, name: 'LilPudgys #10705', image: 'https://i.seadn.io/gcs/files/f9471aeac1b991d36e80b1d71f4c1300.png?auto=format&dpr=1&w=384', price: getPrice(10705) },
          { id: 7871, name: 'LilPudgys #7871', image: 'https://i.seadn.io/gcs/files/cf8fa4a2dffcd25e29d43765b2f5771c.png?auto=format&dpr=1&w=384', price: getPrice(7871) },
          { id: 17665, name: 'LilPudgys #17665', image: 'https://i.seadn.io/gcs/files/1b822dc4613c19cdb236858b365dd78f.png?auto=format&dpr=1&w=384', price: getPrice(17665) },
          { id: 5312, name: 'LilPudgys #5312', image: 'https://i.seadn.io/gcs/files/a69d514ef6b8ddcc694999781b18325c.png?auto=format&dpr=1&w=384', price: getPrice(5312) },
          { id: 17944, name: 'LilPudgys #17944', image: 'https://i.seadn.io/gcs/files/b9e75831fa11c2e13c56f4316200be1c.png?auto=format&dpr=1&w=384', price: getPrice(17944) },
          { id: 17383, name: 'LilPudgys #17383', image: 'https://i.seadn.io/gcs/files/dbb1535378835d7cb6b80dff27ddc1ea.png?auto=format&dpr=1&w=384', price: getPrice(17383) },
          { id: 13548, name: 'LilPudgys #13548', image: 'https://i.seadn.io/gcs/files/306b0a8117c7b124685176465c7b8557.png?auto=format&dpr=1&w=384', price: getPrice(13548) },
          { id: 16757, name: 'LilPudgys #16757', image: 'https://i.seadn.io/gcs/files/85553c737aac9d87a8616a9e25657452.png?auto=format&dpr=1&w=384', price: getPrice(16757) },
          { id: 8357, name: 'LilPudgys #8357', image: 'https://i.seadn.io/gcs/files/a625c7957942d3cecb0dc3b38073d659.png?auto=format&dpr=1&w=384', price: getPrice(8357) },
          { id: 20480, name: 'LilPudgys #20480', image: 'https://i.seadn.io/gcs/files/42dcd04e44877204cb3b53ace11b80c9.png?auto=format&dpr=1&w=384', price: getPrice(20480) },
          { id: 19365, name: 'LilPudgys #19365', image: 'https://i.seadn.io/gcs/files/2b5424af285867d0ce2cb23ce4309f60.png?auto=format&dpr=1&w=384', price: getPrice(19365) },
          { id: 2644, name: 'LilPudgys #2644', image: 'https://i.seadn.io/gcs/files/fe6422cf4556145cb4301d9c0a3d191a.png?auto=format&dpr=1&w=384', price: getPrice(2644) },
          { id: 4632, name: 'LilPudgys #4632', image: 'https://i.seadn.io/gcs/files/c4a1444ee07deedf14758d4e697b0538.png?auto=format&dpr=1&w=384', price: getPrice(4632) },
          { id: 18999, name: 'LilPudgys #18999', image: 'https://i.seadn.io/gcs/files/8b417f70e5b8b772757208c2ead9a70d.png?auto=format&dpr=1&w=384', price: getPrice(18999) },
          { id: 12527, name: 'LilPudgys #12527', image: 'https://i.seadn.io/gcs/files/8cea313fa5fe6ba35a0c989c45e03028.png?auto=format&dpr=1&w=384', price: getPrice(12527) },
          { id: 19237, name: 'LilPudgys #19237', image: 'https://i.seadn.io/gcs/files/dd2bee0e108d49d1f3847177305d957c.png?auto=format&dpr=1&w=384', price: getPrice(19237) },
            
        { id: 19237, name: 'LilPudgys #19237', image: 'https://i.seadn.io/gcs/files/dd2bee0e108d49d1f3847177305d957c.png?auto=format&dpr=1&w=384', price: getPrice(19237) },
          { id: 12922, name: 'LilPudgys #12922', image: 'https://i.seadn.io/gcs/files/4e79b779f4152a85828e9fe51541d657.png?auto=format&dpr=1&w=384', price: getPrice(12922) },
          { id: 7205, name: 'LilPudgys #7205', image: 'https://i.seadn.io/gcs/files/7e5113c74fe9b600296801458a23a61a.png?auto=format&dpr=1&w=384', price: getPrice(7205) },
          { id: 15383, name: 'LilPudgys #15383', image: 'https://i.seadn.io/gcs/files/2cebc98e4b10e9cc1ddb0e5783b55ff7.png?auto=format&dpr=1&w=384', price: getPrice(15383) },
          { id: 775, name: 'LilPudgys #775', image: 'https://i.seadn.io/gcs/files/2d493254f62e68003b6043dc5ba1fcb7.png?auto=format&dpr=1&w=384', price: getPrice(775) },
          { id: 18527, name: 'LilPudgys #18527', image: 'https://i.seadn.io/gcs/files/48a1ca3584781dda4b93a331e53d5159.png?auto=format&dpr=1&w=384', price: getPrice(18527) },
          { id: 21691, name: 'LilPudgys #21691', image: 'https://i.seadn.io/gcs/files/362422abbf34d8c74af66e8a088eafc5.png?auto=format&dpr=1&w=384', price: getPrice(21691) },
          { id: 14290, name: 'LilPudgys #14290', image: 'https://i.seadn.io/gcs/files/b937fb44f56ceeb37f193288f29c4bee.png?auto=format&dpr=1&w=384', price: getPrice(14290) },
          { id: 1794, name: 'LilPudgys #1794', image: 'https://i.seadn.io/gcs/files/b90e19d1ff5e7a49e8d0c5d1d17adec0.png?auto=format&dpr=1&w=384', price: getPrice(1794) },
          { id: 9700, name: 'LilPudgys #9700', image: 'https://i.seadn.io/gcs/files/fc96c314bde191116e4c23bdcd31235b.png?auto=format&dpr=1&w=384', price: getPrice(9700) },
          { id: 2811, name: 'LilPudgys #2811', image: 'https://i.seadn.io/gcs/files/0934178995c9141b2b9d0054858ff911.png?auto=format&dpr=1&w=384', price: getPrice(2811) },
          { id: 12687, name: 'LilPudgys #12687', image: 'https://i.seadn.io/gcs/files/f91469c5a86f6fb51f78804b0f025dcd.png?auto=format&dpr=1&w=384', price: getPrice(12687) },
          { id: 3249, name: 'LilPudgys #3249', image: 'https://i.seadn.io/gcs/files/2b3766cdd24814aec1827d9c0a461e21.png?auto=format&dpr=1&w=384', price: getPrice(3249) },
          { id: 13537, name: 'LilPudgys #13537', image: 'https://i.seadn.io/gcs/files/9bf37918470befd50c428eaa27074bd3.png?auto=format&dpr=1&w=384', price: getPrice(13537) },
          { id: 11518, name: 'LilPudgys #11518', image: 'https://i.seadn.io/gcs/files/c44aea38b7dad82d002d07ac5a1486cb.png?auto=format&dpr=1&w=384', price: getPrice(11518) },
          { id: 11094, name: 'LilPudgys #11094', image: 'https://i.seadn.io/gcs/files/fbffe75b2d84f9ac392842c2940d3950.png?auto=format&dpr=1&w=384', price: getPrice(11094) },
          { id: 12309, name: 'LilPudgys #12309', image: 'https://i.seadn.io/gcs/files/f9af52c5529cc9104c91c86adaf4e576.png?auto=format&dpr=1&w=384', price: getPrice(12309) },
          { id: 15127, name: 'LilPudgys #15127', image: 'https://i.seadn.io/s/raw/files/d128fb786fd71e0ae48c93a1e01a9b33.png?auto=format&dpr=1&w=384', price: getPrice(15127) },
          { id: 12276, name: 'LilPudgys #12276', image: 'https://i.seadn.io/gcs/files/00c23f99fc4e6ae07472ace335dc2ad6.png?auto=format&dpr=1&w=384', price: getPrice(12276) },
          { id: 21556, name: 'LilPudgys #21556', image: 'https://i.seadn.io/gcs/files/35e838d0816e26ead775bb95dd6b39f6.png?auto=format&dpr=1&w=384', price: getPrice(21556) },
          { id: 20589, name: 'LilPudgys #20589', image: 'https://i.seadn.io/gcs/files/455168abed5cf0c396ad2fcede4a1b54.png?auto=format&dpr=1&w=384', price: getPrice(20589) },
          { id: 16885, name: 'LilPudgys #16885', image: 'https://i.seadn.io/gcs/files/761d3d26539c2d8f5577f915e231a664.png?auto=format&dpr=1&w=384', price: getPrice(16885) },
          { id: 13365, name: 'LilPudgys #13365', image: 'https://i.seadn.io/gcs/files/560c573e14fec06a67f3b7a615f37839.png?auto=format&dpr=1&w=384', price: getPrice(13365) },
          { id: 13189, name: 'LilPudgys #13189', image: 'https://i.seadn.io/gcs/files/24cb007cd91b12b7f87fbfe3a99dc8b5.png?auto=format&dpr=1&w=384', price: getPrice(13189) },
          { id: 10690, name: 'LilPudgys #10690', image: 'https://i.seadn.io/gcs/files/421f9217b71dd56ee27418bbe89809f3.png?auto=format&dpr=1&w=384', price: getPrice(10690) },
          { id: 16159, name: 'LilPudgys #16159', image: 'https://i.seadn.io/gcs/files/b1301bc6e375ff0a196f0ec572877105.png?auto=format&dpr=1&w=384', price: getPrice(16159) },
          { id: 18230, name: 'LilPudgys #18230', image: 'https://i.seadn.io/gcs/files/5bb4932c896c743cfc2fa580bea3bcc8.png?auto=format&dpr=1&w=384', price: getPrice(18230) }
    
        ];
        setSampleNfts(lilPudgyNfts.sort((a, b) => parseFloat(a.price) - parseFloat(b.price)));
      } else if (collectionId === 'mutant-ape-yacht-club') {
        setSampleNfts(mutantApeYachtClubNfts);
      } else if (collectionId === 'doodles') {
        setSampleNfts(doodlesNfts);
          } else if (collectionId === 'beanz') {
  setSampleNfts(beanzNfts);
              } else if (collectionId === 'boredapeyachtclub') {
  setSampleNfts(boredApeYachtClubNfts);
} else if (collectionId === 'jirasan') {
  setSampleNfts(jirasanNfts);
    } else if (collectionId === 'redacted-remilio-babies') {
  setSampleNfts(remilioBabiesNFTs);
} else if (collectionId === 'mocaverse') {
  setSampleNfts(mocaverseNFTs);
    } else if (collectionId === 'bit-bears') {
  setSampleNfts(bitBearsNFTs);
         } else if (collectionId === 'the-captainz') {
  setSampleNfts(captainzNFTs);
           } else if (collectionId === 'kanpai-pandas') {
  setSampleNfts(pandasNFTs);
               } else if (collectionId === 'sappy-seals') {
  setSampleNfts(sappysealsNFTs);
         } else if (collectionId === 'sproto-gremlins') {
  setSampleNfts(sprotoNFTs);  
         } else if (collectionId === 'cryptodickbutts-s3') {
  setSampleNfts(cryptodickbuttsNFTs);     
          } else if (collectionId === 'creepz-by-overlord') {
  setSampleNfts(CreepzbyOVERLORDNFTs); 
          } else if (collectionId === 'infinigods') {
  setSampleNfts(InfiniGodsNFTs);      
           } else if (collectionId === 'honey-comb') {
  setSampleNfts(honeyCombNFTs);
            } else if (collectionId === 'opepen-edition') {
  setSampleNfts(opepenNFTs);   
             } else if (collectionId === 'async-blueprints') {
  setSampleNfts(asyncNFTs);  
           } else if (collectionId === 'cool-cats') {
  setSampleNfts(coolcatsNFTs);      
           } else if (collectionId === 'band-bears') {
  setSampleNfts(bandbearsNFTs);         
           } else if (collectionId === 'potatoz') {
  setSampleNfts(potatozNFTs);         
            } else if (collectionId === 'xpsr-24') {
  setSampleNfts(xpsrNFTs);              
             } else if (collectionId === 'kanpai-pandas-infinity') {
  setSampleNfts(kanpaiinfinityNFTs); 
            } else if (collectionId === 'cyberkongz') {
  setSampleNfts(cyberkongzNFTs);     
             } else if (collectionId === 'a-kid-called-beast') {
  setSampleNfts(akidcalledbeastNFTs);     
             } else if (collectionId === 'chimpers') {
  setSampleNfts(chimpersNFTs);  
             } else if (collectionId === 'proof-of-narnian-nft') {
  setSampleNfts(proofofnarnianNFTs);  
              } else if (collectionId === 'project-aeon') {
  setSampleNfts(projectaeonNFTs);      
              } else if (collectionId === 'boredapekennelclub') {
  setSampleNfts(boredapekennelNFTs);  
              } else if (collectionId === 'degods') {
  setSampleNfts(DeGodsNFTs);       
     } else if (collectionId === 'clonex') {
  setSampleNfts(cloneXNFTs); 
         } else if (collectionId === 'quirkies-originals') {
  setSampleNfts(quirkiesNFTs); 
          } else if (collectionId === 'mfer') {
  setSampleNfts(mfersNFTs);
           } else if (collectionId === 'goblintown') {
  setSampleNfts(goblintownNFTs);   
             } else if (collectionId === 'checks-vv-originals') {
  setSampleNfts(vvchecksNFTs);   
             } else if (collectionId === 'snackgang') {
  setSampleNfts(snackgangNFTs);       
             } else if (collectionId === 'metawinners') {
  setSampleNfts(metawinnersNFTs);     
              } else if (collectionId === 'pirate-nation-founders') {
  setSampleNfts(piratenationNFTs);     
               } else if (collectionId === '2049-reflections') {
  setSampleNfts(reflectionsNFTs);        
  } else if (collectionId === 'emby') {
  setSampleNfts(embyNFTs);  
      } else if (collectionId === 'meebits') {
  setSampleNfts(meebitsNFTs);  
           } else if (collectionId === 'mushboomers') {
  setSampleNfts(mushboomersNFTs);  
            } else if (collectionId === 'digidaigaku') {
  setSampleNfts(digidaigakuNFTs);   
             } else if (collectionId === 'my-pet-hooligan') {
  setSampleNfts(mypethooliganNFTs); 
             } else if (collectionId === 'moonbirds') {
  setSampleNfts(moonbirdsNFTs);     
              } else if (collectionId === 'overworld-incarna') {
  setSampleNfts(overworldincarnaNFTs);        
              } else if (collectionId === 'nakamigos') {
  setSampleNfts(nakamigosNFTs);   
              } else if (collectionId === 'pixelady-maker') {
  setSampleNfts(pixelladymakerNFTs);  
              } else if (collectionId === 'terraforms') {
  setSampleNfts(terraformsNFTs);           
               } else if (collectionId === 'the-plooshies') {
  setSampleNfts(theplooshiesNFTs);        
                 } else if (collectionId === 'killabears') {
  setSampleNfts(killabearsNFTs); 
                 } else if (collectionId === 'radbro-webring') {
  setSampleNfts(radrowebringNFTs); 
                 } else if (collectionId === 'v1-cryptopunks-wrapped') {
  setSampleNfts(v1punksNFTs);      
           } else if (collectionId === 'khuga-by-khuga-labs') {
  setSampleNfts(khugaNFTs);       
           } else if (collectionId === 'sugartown-oras') {
  setSampleNfts(sugartownNFTs); 
            } else if (collectionId === 'the-plague-nft') {
  setSampleNfts(theplagueNFTs);   
              } else if (collectionId === 'rosentica-starfall-travelers') {
  setSampleNfts(rosenticaNFTs);    
             } else if (collectionId === 'persona') {
  setSampleNfts(personaNFTs); 
                 
                 
              } else {
        // For other collections, use placeholder images
        const nfts = Array(12).fill(null).map((_, index) => ({
          id: `${foundCollection.id}-${index + 1}`,
          name: `${foundCollection.name} #${Math.floor(Math.random() * 10000)}`,
          image: foundCollection.image,
          price: (Math.random() * 5 + foundCollection.floorPrice).toFixed(2) + ' ETH'
        }));
        setSampleNfts(nfts.sort((a, b) => parseFloat(a.price) - parseFloat(b.price)));
      }

      setLoading(false);
    };

    loadCollection();
  }, [collectionId, navigate]);

  if (loading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        bgcolor: '#0F1624'
      }}>
        <CircularProgress sx={{ color: '#00F5FF' }} />
      </Box>
    );
  }

  if (!collection) {
    return null;
  }

  return (
    <Box sx={{ bgcolor: '#0F1624', minHeight: '100vh', color: 'white' }}>
      {/* Collection Header */}
      <Box sx={{ 
        pt: 3, 
        pb: 4, 
        borderBottom: '1px solid rgba(0, 245, 255, 0.1)',
        background: 'linear-gradient(180deg, rgba(0, 245, 255, 0.05) 0%, rgba(15, 22, 36, 0) 100%)'
      }}>
        <Container maxWidth="xl">
          <Stack direction="row" spacing={3} alignItems="center" sx={{ mb: 3 }}>
            <Avatar
              src={collection.image}
              alt={collection.name}
              sx={{
                width: 80,
                height: 80,
                border: '2px solid rgba(0, 245, 255, 0.3)',
                boxShadow: '0 0 20px rgba(0, 245, 255, 0.1)'
              }}
            />
            <Box>
              <Typography 
                variant="h4" 
                gutterBottom
                sx={{ 
                  color: '#00F5FF',
                  textShadow: '0 0 20px rgba(0, 245, 255, 0.3)'
                }}
              >
                {collection.name}
              </Typography>
              
              {/* Social Media Icons */}
              {collection.id !== "mutant-ape-yacht-club" && (
                collection.id === "pudgypenguins" ? (
                <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                  <IconButton 
                    size="small"
                    href="https://x.com/pudgypenguins"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#8F9BB7',
                      '&:hover': { color: '#00F5FF' },
                      padding: '4px'
                    }}
                  >
                    <TwitterIcon fontSize="small" />
                  </IconButton>
                  <IconButton 
                    size="small"
                    href="https://www.pudgypenguins.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#8F9BB7',
                      '&:hover': { color: '#00F5FF' },
                      padding: '4px'
                    }}
                  >
                    <LanguageIcon fontSize="small" />
                  </IconButton>
                  <IconButton 
                    size="small"
                    href="https://discord.com/invite/pudgypenguins"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#8F9BB7',
                      '&:hover': { color: '#00F5FF' },
                      padding: '4px'
                    }}
                  >
                    <DiscordIcon fontSize="small" />
                  </IconButton>
                </Stack>
      
      ) : collection.id === "doodles" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/doodles"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.doodles.app/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/doodles"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>
      
      ) : collection.id === "kaito-genesis" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/_kaitoai"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://kaito.ai/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/s67HTdxpGA"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>
      
      ) : collection.id === "beanz" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/Azuki"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.azuki.com/beanz"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/azuki"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>
      
      ) : collection.id === "boredapeyachtclub" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/BoredApeYC"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.boredapeyachtclub.com/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/3P5K3dzgdB"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>
      
      ) : collection.id === "jirasan" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/JirasanOfficial"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.jirasan.io/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/projectgodjira"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>
      
      ) : collection.id === "redacted-remilio-babies" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/RemilioBaby"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://remilio.org/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
  </Stack>
      
      ) : collection.id === "mocaverse" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/Moca_Network"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.mocaverse.xyz/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
  </Stack>
      
      ) : collection.id === "bit-bears" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/berachain"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.berachain.com/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/berachain"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>
      
      ) : collection.id === "the-captainz" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/Memeland"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.memeland.com/captainz"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/memeland"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>
      
       
      ) : collection.id === "kanpai-pandas" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/KanpaiPandas"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://kanpaipandas.com/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/kanpaipandas"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>
         
         
      ) : collection.id === "sappy-seals" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/SappySealsNFT"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.sappy.lol/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/zy2dfyMKwE"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>
             
       ) : collection.id === "sproto-gremlins" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/sprotogremlins"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://hpos10i.com/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
  </Stack>
      
      
       ) : collection.id === "cryptodickbutts-s3" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/CryptoDickbutts"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://cryptodickbutts.com/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/uhRmzP7Uuu"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>
           
        
       ) : collection.id === "creepz-by-overlord" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/Overlord_xyz"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.overlord.xyz/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/overlordxyz"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>
     
         
       ) : collection.id === "infinigods" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/InfiniGods"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.infinigods.com/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/6GXt9ewEW3"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>
      
     ) : collection.id === "honey-comb" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://www.0xhoneyjar.xyz/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
  </Stack>
  
       ) : collection.id === "rg-bytes" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/Revolving_Games"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.revolvinggames.com/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
  </Stack>
      
      ) : collection.id === "no-more-liquidity-gen" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/NoMoreLiquidity"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
  </Stack>
      
         
       ) : collection.id === "cool-cats" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/coolcats"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://coolcats.com/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/coolcatsnft"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>
       
      
      ) : collection.id === "dooplicator" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/doodles"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.doodles.app/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/doodles"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>
      
   ) : collection.id === "infinigods-god-vaults" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/InfiniGods"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.valhallafoundation.xyz/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/kingofdestiny"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>
         
      
        
   ) : collection.id === "potatoz" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/memeland"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.memeland.com/potatoz"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/memeland"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>
         
      
      ) : collection.id === "xpsr-24" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/xpsr_"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://one.confiction.com/xpsr"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/confiction"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>     
      
     
      ) : collection.id === "kanpai-pandas-infinity" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/KanpaiPandas"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://kanpaipandas.com/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/kanpaipandas"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>       
      
     ) : collection.id === "cyberkongz" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/CyberKongz"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.cyberkongz.com/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/cyberk"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack> 
      
      
       ) : collection.id === "a-kid-called-beast" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/akidcalledbeast"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.akidcalledbeast.com/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/akidcalledbeast"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>       
       
      
       ) : collection.id === "chimpers" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/ChimpersNFT"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.chimpers.xyz/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/chimpers"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>       
       
       
       ) : collection.id === "proof-of-narnian-nft" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/ICODrops"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://dropscapital.com/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://dropscapital.com/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>       
       
      
       ) : collection.id === "project-aeon" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/ProjectAeon3333"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.spx6900.com/"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/projectaeon"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>       
       
      
      
       ) : collection.id === "boredapekennelclub" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/boredapeyc"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://boredapeyachtclub.com/#/kennel-club"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/wjH7hGz2yS"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>       
      
        
      
       ) : collection.id === "degods" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/DeGodsNFT"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://de.xyz"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/dexyz"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>       
      
      
      
       ) : collection.id === "clonex" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/RTFKT"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://rtfkt.com"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/rtfkt"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>       
      
      
       
       ) : collection.id === "quirkies-originals" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/quirkiesnft"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.quirkies.io"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/WhVu9eHrgC"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>       
      
      
       ) : collection.id === "mfer" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/unofficialmfers"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://mirror.xyz/sartoshi.eth/QukjtL1076-1SEoNJuqyc-x4Ut2v8_TocKkszo-S_nU"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/sgBJhcHxr8"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>       
      
     
       ) : collection.id === "goblintown" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/goblintown"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://goblintown.com"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://etherscan.io/address/0x8c6def540b83471664edc6d5cf75883986932674"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
      
       ) : collection.id === "checks-vv-originals" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/jackbutcher"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.jack.art"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://etherscan.io/address/0x036721e5a769cc48b3189efbb9cce4471e8a48b1"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
    
      
 ) : collection.id === "snackgang" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/SNACKG_"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://snackgang.gg"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/kSAdndsgBr"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
      
       ) : collection.id === "metawinners" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/Meta_Winners"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://metawin.com"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/hjXh8FmK"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
    
      
       ) : collection.id === "pirate-nation-founders" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/Meta_Winners"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://piratenation.game"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/hjXh8FmK"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
        ) : collection.id === "2049-reflections" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/freysa_ai"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.freysa.ai"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://etherscan.io/address/0x3bfb2f2b61be8f2f147f5f53a906af00c263d9b3"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
      
        ) : collection.id === "emby" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/play_ember"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://playember.com"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/emby"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
      
        ) : collection.id === "meebits" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/MeebitsNFTs"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://meebits.app"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/meebits"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
      
       ) : collection.id === "proof-pass" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/PROOFplatform"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://proofplatform.io"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://etherscan.io/address/0x2ced5bc349d9241a314d3739f12f5f6f2bda6a68"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
       
       ) : collection.id === "mushboomers" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/Mushboomers"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://mushboomers.com"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/nftinitcom"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
        
       ) : collection.id === "digidaigaku" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/Digidaigaku"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://digidaigaku.com/home"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/qHqsDJMTha"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
      
       ) : collection.id === "my-pet-hooligan" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/mypethooligan"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.mypethooligangame.com"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/mypethooligan"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
      
       ) : collection.id === "moonbirds" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/moonbirds"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.proof.xyz/moonbirds"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://etherscan.io/address/0x23581767a106ae21c074b2276d25e5c3e136a68b"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
   
        ) : collection.id === "overworld-incarna" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/OverworldPlay"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.overworld.games"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/overworldplay"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
         ) : collection.id === "thecurrency" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/heni"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://heni.com/nft"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/HENI"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
      
         ) : collection.id === "nakamigos" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/Nakamigos"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://nakamigos.io"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://etherscan.io/address/0xd774557b647330c91bf44cfeab205095f7e6c367"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
      
         ) : collection.id === "pixelady-maker" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/PixeladyMaker"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://pixeladymaker.net"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://etherscan.io/address/0x8fc0d90f2c45a5e7f94904075c952e0943cfccfd"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
      
         ) : collection.id === "bythen-chip" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/bythenAI"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.bythen.ai"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/YwxQ5YjkZs"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
      
      
         ) : collection.id === "terraforms" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/mathcastles"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://mathcastles.xyz"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/mathcastles"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
      
        ) : collection.id === "the-plooshies" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/ThePlooshies"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://theplooshies.com"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/theplooshies"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
      
      
        ) : collection.id === "killabears" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/killabearsnft"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://killabears.com"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/fdmWqgaytj"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
      
       ) : collection.id === "skyborne-nexian-gems" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/Revolving_Games"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://skybornegenesis.com"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/skybornelegacy"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
      
      ) : collection.id === "radbro-webring" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/radbro_webring"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://radbro.xyz"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/qUcn7G2JDq"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
     
       
      ) : collection.id === "v1-cryptopunks-wrapped" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/v1punks"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://v1punks.io"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/R4n5vq7qwm"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>        
      
      
      
      ) : collection.id === "khuga-by-khuga-labs" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/Khugaverse"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://khuga.io"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/khuga"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>      
      
      
      
         
      ) : collection.id === "sugartown-oras" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/visitsugartown"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://visitsugartown.com"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://etherscan.io/address/0xd564c25b760cb278a55bdd98831f4ff4b6c97b38"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>      
      
      
      
        ) : collection.id === "the-plague-nft" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/ThePlagueNFT"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://www.plaguebrands.io"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/theplaguenft"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>      
      
      
      
      
        ) : collection.id === "rosentica-starfall-travelers" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/Rosentica"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://rosentica.jp"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/rosentica"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>      
      
      
       ) : collection.id === "persona" ? (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
    <IconButton 
      size="small"
      href="https://x.com/Persona_Journey"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <TwitterIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://personajourney.io"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <LanguageIcon fontSize="small" />
    </IconButton>
    <IconButton 
      size="small"
      href="https://discord.com/invite/prsnjourney"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ 
        color: '#8F9BB7',
        '&:hover': { color: '#00F5FF' },
        padding: '4px'
      }}
    >
      <DiscordIcon fontSize="small" />
    </IconButton>
  </Stack>      
       
      
      
      
  ) : collection.id === "azuki-elementals" ? (
                <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                  <IconButton 
                    size="small"
                    href="https://x.com/Azuki"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#8F9BB7',
                      '&:hover': { color: '#00F5FF' },
                      padding: '4px'
                    }}
                  >
                    <TwitterIcon fontSize="small" />
                  </IconButton>
                  <IconButton 
                    size="small"
                    href="https://www.azuki.com/elementals/reveal"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#8F9BB7',
                      '&:hover': { color: '#00F5FF' },
                      padding: '4px'
                    }}
                  >
                    <LanguageIcon fontSize="small" />
                  </IconButton>
                  <IconButton 
                    size="small"
                    href="https://discord.com/invite/azuki"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#8F9BB7',
                      '&:hover': { color: '#00F5FF' },
                      padding: '4px'
                    }}
                  >
                    <DiscordIcon fontSize="small" />
                  </IconButton>
                </Stack>
              ) : collection.id === "azuki" ? (
                <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                  <IconButton 
                    size="small"
                    href="https://x.com/Azuki"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#8F9BB7',
                      '&:hover': { color: '#00F5FF' },
                      padding: '4px'
                    }}
                  >
                    <TwitterIcon fontSize="small" />
                  </IconButton>
                  <IconButton 
                    size="small"
                    href="https://www.azuki.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#8F9BB7',
                      '&:hover': { color: '#00F5FF' },
                      padding: '4px'
                    }}
                  >
                    <LanguageIcon fontSize="small" />
                  </IconButton>
                  <IconButton 
                    size="small"
                    href="https://discord.com/invite/azuki"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#8F9BB7',
                      '&:hover': { color: '#00F5FF' },
                      padding: '4px'
                    }}
                  >
                    <DiscordIcon fontSize="small" />
                  </IconButton>
                </Stack>
              ) : collection.id === "lilpudgys" ? (
                <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                  <IconButton 
                    size="small"
                    href="https://x.com/pudgypenguins"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#8F9BB7',
                      '&:hover': { color: '#00F5FF' },
                      padding: '4px'
                    }}
                  >
                    <TwitterIcon fontSize="small" />
                  </IconButton>
                  <IconButton 
                    size="small"
                    href="https://www.pudgypenguins.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#8F9BB7',
                      '&:hover': { color: '#00F5FF' },
                      padding: '4px'
                    }}
                  >
                    <LanguageIcon fontSize="small" />
                  </IconButton>
                  <IconButton 
                    size="small"
                    href="https://discord.com/invite/pudgypenguins"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#8F9BB7',
                      '&:hover': { color: '#00F5FF' },
                      padding: '4px'
                    }}
                  >
                    <DiscordIcon fontSize="small" />
                  </IconButton>
                </Stack>
              ) : collection.id === "milady" ? (
                <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                  <IconButton 
                    size="small"
                    href="https://x.com/MiladyMaker333"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#8F9BB7',
                      '&:hover': { color: '#00F5FF' },
                      padding: '4px'
                    }}
                  >
                    <TwitterIcon fontSize="small" />
                  </IconButton>
                  <IconButton 
                    size="small"
                    href="https://miladymaker.net/"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#8F9BB7',
                      '&:hover': { color: '#00F5FF' },
                      padding: '4px'
                    }}
                  >
                    <LanguageIcon fontSize="small" />
                  </IconButton>
                  <IconButton 
                    size="small"
                    href="https://discord.com/invite/milady"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#8F9BB7',
                      '&:hover': { color: '#00F5FF' },
                      padding: '4px'
                    }}
                  >
                    <DiscordIcon fontSize="small" />
                  </IconButton>
                </Stack>
              ) : (
                <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                  <IconButton 
                    size="small"
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#8F9BB7',
                      '&:hover': { color: '#00F5FF' },
                      padding: '4px'
                    }}
                  >
                    <TwitterIcon fontSize="small" />
                  </IconButton>
                  <IconButton 
                    size="small"
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#8F9BB7',
                      '&:hover': { color: '#00F5FF' },
                      padding: '4px'
                    }}
                  >
                    <LanguageIcon fontSize="small" />
                  </IconButton>
                  <IconButton 
                    size="small"
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#8F9BB7',
                      '&:hover': { color: '#00F5FF' },
                      padding: '4px'
                    }}
                  >
                    <DiscordIcon fontSize="small" />
                  </IconButton>
                </Stack>
              )
              )}


              {collection.id === "pudgypenguins" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                  Pudgy Penguins is a collection of 8,888 NFT's, accelerating Web3 innovation through IP utilization and community empowerment. Embodying love, empathy, & compassion, the Pudgy Penguins are a beacon of good vibes & positivity for everyone. Each holder receives exclusive access to experiences, events, IP licensing opportunities and more. Let's break through the boundaries of Web3 together.
                </Typography>
              ) : collection.id === "azuki" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                  Take the red bean to join the garden. View the collection at azuki.com/gallery.{"\n\n"}Azuki starts with a collection of 10,000 avatars that give you membership access to The Garden: a corner of the internet where artists, builders, and web3 enthusiasts meet to create a decentralized future. Azuki holders receive access to exclusive drops, experiences, and more. Visit azuki.com for more details.{"\n\n"}We rise together. We build together. We grow together.
                </Typography>
              ) : collection.id === "azuki-elementals" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                  Azuki Elementals are a collection of 20,000 characters within the four domains of the Garden.{"\n\n"}Take the red bean. azuki.com/elementals/reveal
                </Typography>
              ) : collection.id === "lilpudgys" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                  Lil Pudgys is a collection of 22,222 NFTs originating from Pudgy Penguins. Don't let their small stature fool you, Lil Pudgys are an integral piece of the Pudgy Penguins history. Their story began during the most frigid of winters. In the midst of adversity, the birth of the Lil Pudgys helped spark new-life into the Pudgy Penguins community. With their unique traits and personalities, there's a Lil Pudgy for everyone. Lil Pudgy holders receive exclusive access to experiences, events, IP licensing opportunities and more.
                </Typography>
              ) : collection.id === "mutant-ape-yacht-club" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                  The MUTANT APE YACHT CLUB is a collection of up to 20,000 Mutant Apes that can only be created by exposing an existing Bored Ape to a vial of MUTANT SERUM or by minting a Mutant Ape in the public sale.
                </Typography>
              ) : collection.id === "doodles" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                  The collectibles that started it all. Doodles Original Collection features 10,000 characters created by Co-Founder and renowned artist, Burnt Toast. The generative art was designed with a joyful range of colors, traits and personalities, with 32 hand-drawn, unique, 1 of 1's to round out the set.
                </Typography>
            ) : collection.id === "kaito-genesis" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                  Kaito Genesis is the genesis NFT collection created by Kaito AI.
                </Typography>
            ) : collection.id === "beanz" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                  BEANZ are a small species that sprouts from the dirt in the garden. They make for a great sidekick to an Azuki, although some like to kick it alone. They're earnestly driven by the desire to help. However, certain BEANZ feel a calling to pave their own path....
                </Typography>
           ) : collection.id === "boredapeyachtclub" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                  The Bored Ape Yacht Club is a collection of 10,000 unique Bored Ape NFTs— unique digital collectibles living on the Ethereum blockchain. Your Bored Ape doubles as your Yacht Club membership card, and grants access to members-only benefits, the first of which is access to THE BATHROOM, a collaborative graffiti board. Future areas and perks can be unlocked by the community through roadmap activation. Visit boredapeyachtclub.com for more details.
                </Typography>
           ) : collection.id === "jirasan" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                  A collection of 10,000 NFTs providing premier membership access to the PG Group and Redacted ecosystem.

                  Jirasan’s Official X link: x.com/jirasanofficial

                  PG Group:
                  A web 3 tech startup incubating products and empowering people.  

                  Official PG Group Website:
                  pg-group.io/

                  Redacted:
                  x.com/redactedcoin
                </Typography>
            ) : collection.id === "redacted-remilio-babies" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                  Redacted Remilio Babies is a collection of 10,000 neochibi pfpNFT's expanding the Milady Maker paradigm with the introduction of young J.I.T. energy and schizophrenic reactionary aesthetics. We are #REMILIONAIREs.
                </Typography>
            ) : collection.id === "mocaverse" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                  Mocaverse is the Animoca Brands membership NFT collection of 8,888 unique beings that thrive in unity: The Mocas. There are 5 incredible Moca tribes of the Angels, Builders, Dreamers, Connectors, and Neo-Capitalists. Join the Mocas in the realms to Learn, Play, Do Good, and Build together as we champion our Web3 values! Learn more about the Mocas on our website.
                </Typography>
            ) : collection.id === "bit-bears" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                  2355 Bit Bears ready to build on Berachain
                </Typography>
            ) : collection.id === "the-captainz" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                  9,999 PIRATE CAPTAINZ SEARCHING FOR THE LEGENDARY MEMELAND.

                  9,999 Captainz, with their pirate crewz, explore the Broken Seas in search of the legendary treasure known as “Memeland”. Join them in their quests for glory, fortune, love, and of course… memes.
                </Typography>
             ) : collection.id === "kanpai-pandas" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                  8 chain omni-chain pioneers. We minted out through old fashioned grass rooted grinding and built a core product, recognizable brand and a community of rabid “sophisticated degenerates”. Don't just join the club, own it.
                </Typography>
            ) : collection.id === "sappy-seals" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                 Sappy Seals is a decentralized movement that welcomes digital natives to be part of our community. We're creating a safe haven for leaders to grow, creators to find opportunities, and for all to be part of a growing positive force in the world.
                </Typography>
                  
            ) : collection.id === "sproto-gremlins" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                 Twitter • @sprotogremlins | Sproto Gremlins are 3,333 exclusive unique manifestations of harrypotterobamasonic10inu's egregore. Imbued with high speed presidential wizardry and lifelong loyalty.

                 🎨Creators: @juicyunlimited & @iamnick44

                 Telegram • t.me/hpos10i
                 0x72e4f9F808C49A2a61dE9C5896298920Dc4EEEa9
                </Typography>
                  
            ) : collection.id === "cryptodickbutts-s3" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                 Once a utopia, Gooch Island has fallen and CryptoDickbutts have been evacuated. Series 3 features 5200 all new CryptoDickbutts, each with a set of randomly generated traits.

                 Keep away from children.
                </Typography>
            
            ) : collection.id === "creepz-by-overlord" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                Creepz rule, humans drool. creepz.co
                </Typography>
                  
            ) : collection.id === "infinigods" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
               The InfiniPass is an all-access pass to the InfiniGods Universe (IGU) of blockchain games. Passes provide access to early gameplay content, bonus play periods, exclusive NFT drops, powerful boosts, and much more — for life.

               Two passes exist in the IGU: the Community Pass and Ultimate Pass.

               The Community Pass (3,188 exist): Designed for a broader group of gamers. Provides early access to InfiniGods games, special perks during future mints, passive gameplay boosts, and access to exclusive tournaments & prize pools.

               The Ultimate Pass (260 exist): Designed for those that want to travel deeper into the InfiniGods Universe as a VIP. Provides all benefits of the Community Pass, plus: free NFTs for every InfiniGods release in perpetuity, enhanced gameplay boosts, access to the Roundtable (private VIP Discord community), & inside access to the IG game development team.
                </Typography>
               
            ) : collection.id === "rg-bytes" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                Rewards with Byte

                The RG Byte is your all-access pass to the Revolving Games ecosystem.

                It's your digital rewards card where you can earn loyalty points by discovering and playing games. These points will be convertible to Tokens, Game NFTs, real-life rewards, and future ecosystem airdrops.

                Discover, Play, Earn, and Redeem.

                Developed by Revolving Games and backed by industry giants such as Pantera Capital, Animoca Brands, Polygon, and many others.

                Official Revolving Games Collections:
                nexus nodes
                rg bytes
                genesis immortals
                genesis loot
                </Typography>
                
            ) : collection.id === "no-more-liquidity-gen" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                No More Liquidity: Genesis Pass
                Grants access to the exclusive token-gated “No More Liquidity” trading community

                Join link:
                telegram.me/collablandbot?start=vfbdi1rftcndt01niy0xmdaymdgwndy4ntg5

                Twitter:
                x.com/nomoreliquidity
                </Typography>
            
             ) : collection.id === "cool-cats" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                Cool Cats is a collection of 9,999 randomly generated and stylistically curated NFTs that exist on the Ethereum Blockchain. Cool Cat holders can participate in exclusive events such as NFT claims, raffles, community giveaways, and more. Remember, all cats are cool, but some are cooler than others.
                </Typography>
                
            ) : collection.id === "dooplicator" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
               The Dooplicator is supercharged with endless utility.

               The Dooplicator's 'charges', allows its Doodle-y matter to utilize other NFTs to create new content.

               Planned upgrades to its firmware will allow Dooplicators, even used ones, to be utilized in new and different ways.
                </Typography>
                
         ) : collection.id === "infinigods-god-vaults" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
               GOD VAULTS generate $GOD COIN, the token powering the InfiniGods Universe; launching in partnership with the Valhalla Foundation. GOD VAULTS are a collection of powerful, god-tier artifacts — and the latest addition to the InfiniGods Universe. Owning a GOD VAULT grants access to Valhalla Staking, a novel staking platform with unique mechanics. By staking Vaults, holders can earn ongoing rewards in the form of $GOD COIN, with opportunities to boost their rewards through a gamified leveling system. Dedicated stakers may also receive unexpected bonuses—after all, you never know when the Gods might smile upon you.
                </Typography>
                
         ) : collection.id === "potatoz" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
               9,999 SMALL SPECIES LEADING THE WAY TO MEMELAND.A long time ago, in a memetaverse far, far away… Memeland was a deserted land unsuitable for life. Until [redacted] years ago, early lifeforms started to appear. Memeland's first residents, it turns out, were a bunch of Potatoz. Who left the Potatoz there?The Potatoz is a collection of 9,999 utility-enabled PFPs. Each Potatoz is your entry ticket into the great memeland ecosystem. They make for a great side dish, but some may feel a calling to become the main course.
                </Typography>
                
         ) : collection.id === "xpsr-24" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
               XPSR-24 is the premier collection of the Occultical Universe — the Universe of RIFTSTORM.
                </Typography>
                
         ) : collection.id === "kanpai-pandas-infinity" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
               250 Infinity Pandas ♾ originating from a Kanpai Panda on each of our previously mintable chains. Music exclusively produced by Dr. Fresch.
                </Typography>
                
         ) : collection.id === "cyberkongz" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
               Welcome to an alternate reality, where evolution took a different route and weird apes roam the earth.
               Some appear normal. Some look weird. And some are just damn cool!
               Every CyberKong is unique and owns randomized items with different rarities. A few are super rare and even animated!
               **Maybe some of them look familiar!**
                </Typography>
                
         ) : collection.id === "a-kid-called-beast" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
              A digital collectible at the intersect of art, culture, fashion & music. Activate your BEAST at hub.akidcalledbeast.com
                </Typography>
                  
        ) : collection.id === "chimpers" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
             Chimpers are a collection of 5,555 generative NFT pixel art characters by @TimpersHDChimpers
                </Typography>
                
        ) : collection.id === "proof-of-narnian-nft" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
             Original Crypto Narnian NFT collection. 3 333 NFT tokens with unique zero value.

             Proof of Narnian NFT represents the largest and most authentic crypto community founded in 2018. Powered by ICO Drops.
                </Typography>
                
        ) : collection.id === "project-aeon" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
             If we could harness the power of God, could we flip the S&P500?

             Deep within the clandestine vaults of SPX6900 Labs, a radical research experiment codenamed "Project AEON" sought the answer to this question.

             But then, the unexpected happened.

             A phenomenon known as a quantum glitch occurred, sparking life into 3333 Aeons - beings neither of this world nor wholly apart from it.

             These entities, birthed from the crucible of human ambition and cosmic anomaly, could save us.
                </Typography>
                
        ) : collection.id === "boredapekennelclub" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
             It gets lonely in the swamp sometimes. That's why every ape should have a four-legged companion. To curl up at your feet. To bring you a beer. To fire a missile launcher at that bastard Jimmy the Monkey.

             That's why we've started the Bored Ape Kennel Club, and why we're offering up a dog NFT for adoption to every single member of the BAYC – for free (you only pay gas).

             Learn more at: http://boredapeyachtclub.com/#/kennel-club
                </Typography>
                
        ) : collection.id === "degods" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
             A collection of degenerates, punks, and misfits. Gods of the metaverse & masters of our own universe.
                </Typography>
                
         ) : collection.id === "clonex" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
             🧬 CLONE X 🧬

             20,000 next-gen Avatars, by RTFKT and Takashi Murakami 🌸
                </Typography>
                
         ) : collection.id === "quirkies-originals" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
            Quirkies with maps are off questing and cannot be purchased.
                </Typography>
                
         ) : collection.id === "mfer" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
            mfers are generated entirely from hand drawings by sartoshi. this project is in the public domain; feel free to use mfers any way you want.
                </Typography>
                
         ) : collection.id === "goblintown" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
            AAAAAAAUUUUUGGGHHHHH gobblins goblinns GOBLINNNNNNNNns wekm ta goblintown yoo sniksnakr DEJEN RATS oooooh rats are yummmz dis a NEFTEEE O GOBBLINGS on da BLOKCHIN wat? oh. crustybutt da goblinking say GEE EMMM DEDJEN RUTS an queenie saay HLLO SWEATIES ok dats all byeby
                </Typography>
                
         ) : collection.id === "checks-vv-originals" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
            This artwork may or may not be notable.
                </Typography>
                
         ) : collection.id === "snackgang" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
            A limited collection of 5,555 NFTs granting VIP access to the SNACK ecosystem, exclusive perks, and a front-row seat to dynamic community-driven initiatives.
                </Typography>
                
        ) : collection.id === "metawinners" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
            Introducing the MetaWinners NFT Collection!

            This is it, folks - the moment you’ve been waiting for. The MetaWinners NFTs are HERE!

            10,000 stunning PFPs are ready for you to collect and use as your personal badge of honor across The Arena Discord, MetaWin.com, the forthcoming HIT.com, HIT.tv and throughout the entire Web3 ecosystem.

            To participate in our free to enter prize draws, connect with your Web3 wallet to www.metawin.com. $300,000 already won by MetaWinners NFT holders and climbing.

            To check out the greatest community in Web3, come and hang with us in The Arena Discord. discord.gg/the-arena
                </Typography>
                
        ) : collection.id === "pirate-nation-founders" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
           ⚠️ IMPORTANT: Wallets that received their first Founder's Pirates after 4:09pm ET on Monday, September 11th, 2023 will be unable to export in-game items until they obtain a Trade License or Command Rank 10 in-game.Take to the seas with your pirate crew! Explore the world and gather XP, loot, and untold riches in a race to become the world's greatest pirate captain! Play at piratenation.game
                </Typography>
                
        ) : collection.id === "2049-reflections" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
           2049 // Reflections
                </Typography>
                
                
        ) : collection.id === "emby" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
           Emby is the genesis collection from Playember are unique 3D characters who are your companion in the biggest casual gaming ecosystem in web3!

           Emby is brought to you by Playember, the leading web3 casual game studio backed by a team with over 5 million monthly players and 120 million downloads of their mobile games .
                </Typography>
                  
                
        ) : collection.id === "meebits" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
           The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.
                </Typography>
                
                
       ) : collection.id === "proof-pass" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
           The PROOF Pass is your ticket to gaining early-access to the hottest new crypto projects launching on the PROOF Platform. Join our token-gated private telegram group to get instant alerts when a PROOF token launches.

           **About PROOF**
           PROOF is the most powerful way to launch a token, with battle-tested features designed to set you up for success. Our contracts are audited & unruggable.
                </Typography>
                
      ) : collection.id === "mushboomers" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
           Mushbooomers might have utilities. "If you want to keep a secret, you must also hide it from yourself."
                </Typography>
                
                
     ) : collection.id === "digidaigaku" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
           DigiDaigaku is a collection of 2022 unique characters developed by Limit Break, a company founded by world famous game designers Gabriel Leydon and Halbert Nakagawa. Currently, DigiDaigaku characters live in a mysterious world unknown to outsiders, but in time, exciting details about their world will be revealed.
                </Typography>
                
    ) : collection.id === "my-pet-hooligan" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
           A genesis collection of 8888 Pet Hooligans – unique 3D characters that are posed to defend Web3 from the corporate overlord, MetaZuckBot.

           Each Hooligan provides access to the AMGI Studio's suite of animation products, and are also your playable avatars in the social-action, multiplayer game My Pet Hooligan - free-to-play early access out now!

           Sequi Lepus.
                </Typography>
                
     ) : collection.id === "moonbirds" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
           Moonbirds is a home for creatives, dreamers, and collectors seeking real connection as we all contribute to the future of web3 art, culture, and technology.

           Moonbird art is entirely in-chain, meaning the images are outputted directly from the smart contract, with no need for storage on IPFS or the like. There are also a number of customisable backgrounds available to holders based on their on-chain activity (such as other NFT holdings)—which disappear when the bird is transferred. You can check what each bird looks like with the different backgrounds on our site
                </Typography>
            
     ) : collection.id === "overworld-incarna" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
           Enter the Overworld and become Incarna, god amongst mortals. Unleash your power and reign supreme in a world where your every command shapes destinies.
                </Typography>
                
    ) : collection.id === "thecurrency" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
           HENI is delighted to present The Currency, the first NFT collection by Damien Hirst.

           Starting with the creation of the physical artworks in 2016, The Currency explores the boundaries of art and currency—when art changes and becomes a currency, and when currency becomes art.

           Collectors had 1 year to decide between the digital NFT or the physical artwork, both of which are artworks in their own right. Whichever was picked, the other got burned.

           After the Exchange deadline, on 27th July 2022, the final NFT Supply is 4,851 NFTs. 5,149 NFTs were burned in exchange for the physical artworks.

           The collection was launched on the Palm blockchain, which is a token-powered ecosystem for NFTs connected to Ethereum. It is 99% more energy efficient than proof of work systems such as Bitcoin. The Currency NFTs can be moved to Ethereum using the Palm NFT Bridge.
                </Typography>
                
                
     ) : collection.id === "nakamigos" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
           20,000 unique crypto investors on the blockchain with commercial rights. Twitter: @nakamigos.
                </Typography>
                
    ) : collection.id === "pixelady-maker" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
           Pixelady Maker is a collection of 10000 generative pixel art pfpNFT's in a neochibi aesthetic inspired by Milady Maker.
                </Typography>
                
     ) : collection.id === "bythen-chip" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
           A limited collection of NFTs that serves as a gateway to the bythen ecosystem. This collection grants early access to your bythen AI avatar, an upcoming airdrop, and other benefits within our key initiatives. Visit www.bythen.ai for more details.
                </Typography>
                
    ) : collection.id === "terraforms" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
           Onchain land art from a dynamically generated onchain 3D world.
                </Typography>
                
                
    ) : collection.id === "the-plooshies" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
           Introducing The Plooshies, an NFT collection showcasing 3333 fully rigged and animated 3D models of 11 unique characters. This innovative project seeks to revive cherished childhood memories while emphasizing interactive storytelling, community involvement, and gaming as its core pillars. Embark on thrilling adventures alongside Penelope, Viktor, and their friends, and immerse yourself in an incredibly fun experience!
                </Typography>
                
    ) : collection.id === "killabears" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
          Welcome to the Killaverse. A world designed for the next generation of digital entertainment. As a member, you'll be swept away on a unique, and unforgettable journey.

          **Download all your assets (pfp, video, gif and more) by connecting to your dashboard**

          Find bears eligible for staking experiences - visit our bear portal

          Killabears are the stars of the Killaverse. This collection of 3,333 horrifyingly lovable digital collectible characters unlocks access to ongoing immersive entertainment experiences, and a community like no other. Plus - commercial IP rights mean you can build anything you can imagine.

          Need help getting started? check out the overview here
                </Typography>
            
            
    ) : collection.id === "skyborne-nexian-gems" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
          Skyborne - Nexian Gems is a Proof of Collective within the Skyborne Legacy ecosystem.These limited gems hold significant value and provide holders with special privileges. Holders gain guaranteed access to whitelist for future Skyborne mints, ensuring early access to new collectibles, as well as access to the Revolving Games Partner Node Network.Nexian Gem holders will receive a free Node to run for rewards in the months following our token launch. These Nodes will be limited for our highest valued community members with important rights to community decisions.Developed by Revolving Games and backed by industry giants such as Pantera Capital, Animoca Brands, Polygon, and many others.Official Skyborne Legacy Collections.
                </Typography>
                
                
    ) : collection.id === "radbro-webring" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
          Radbros on chain. Just tell 'em to check the chain.

          Radbros get **$RAD**.
                </Typography>
                
                
     ) : collection.id === "v1-cryptopunks-wrapped" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
          CryptoPunks, released on June 9, 2017 by Larva Labs.

          This is the original ERC-20 token now tradeable via a modern ERC-721 wrapper.

          wiki | twitter 
                </Typography>
                
                            
     ) : collection.id === "khuga-by-khuga-labs" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
          Fighter cats battling in the Khugaverse, walk on an adventurous journey, play some fun battles and quests, and get exciting rewards.
                </Typography>
                
    ) : collection.id === "sugartown-oras" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
          Oras are a collection of 9,999 unique beings from another dimension. They entered Sugartown through a rift in the space-time continuum that was accidentally created when the trio of farm friends were developing games.
                </Typography>
                
                
     ) : collection.id === "the-plague-nft" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
          Plaguing the blockchain with 10,725 Frogs || Be a Plague ||
                </Typography>
                
                
    ) : collection.id === "rosentica-starfall-travelers" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
          Welcome to Elvinia, Starfall Travelers 🌠

          Embark on a wondrous journey with the "Starfall Travelers" Collection, the original genesis of the fantasy series Rosentica. This exquisite collection comprises 6000 unique travelers, each a living testament to the dual worlds of Earth and Elvinia. Crafted with perfectionism and dedication over a year and a half, these travelers spring from the creative wellspring of the concept artist, Okku, brought to life through each meticulous stroke of the brush. Curated with craftsmanship by Natsuki, every traveler in this collection is not only a digital collectible but a character design, a canvas awaiting its collector's narrative to unfold their tales.

          “Starfall Travelers” Collection is The OG Collectibles and POES of Fantasy Series Rosentica. For Novel, Music, News about Animation and Game Release, visit rosentica.jp/ to explore the world of Rosentica.
                </Typography>
                
                
    ) : collection.id === "persona" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
          Timefall Valley is a small city that has always remained isolated from the outside world. It is a time capsule, reminding us of a cherished past.

          Its citizens, the Personas, are driven by their passions, whether it be sport, art, or fashion. They have been isolated for as long as they can remember, but the 'Persona Program' finally allows them to make contact with 'outsiders.'

          Timefall Valley is calling. Will you answer?
                </Typography>
                
                
                
              ) : (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                  
                </Typography>
              )}
              {collection.id === "milady" ? (
                <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                  Milady Maker is a collection of 10,000 generative pfpNFT's in a neochibi aesthetic inspired by street style tribes.
                </Typography>
                  
              ) : null}
            </Box>
          </Stack>

          <Stack 
  direction="row"
  spacing={{ xs: 1, sm: 4 }}  // Reduced spacing on mobile from 4 to 1
  sx={{ 
    bgcolor: 'rgba(20, 28, 36, 0.5)',
    p: { xs: 1, sm: 2 },     // Reduced padding on mobile
    borderRadius: 1,
    border: '1px solid rgba(0, 245, 255, 0.1)',
    boxShadow: '0 4px 20px rgba(0, 245, 255, 0.05)',
    '& .MuiTypography-body2': {  // Make labels smaller on mobile
      fontSize: { xs: '0.7rem', sm: '0.875rem' }
    },
    '& .MuiTypography-h6': {     // Make values smaller on mobile
      fontSize: { xs: '0.85rem', sm: '1.25rem' }
    },
    '& .MuiChip-root': {         // Make chips smaller on mobile
      fontSize: { xs: '0.75rem', sm: '0.875rem' },
      height: { xs: '24px', sm: '32px' }
    }
  }}
          >
            <Box>
              <Typography variant="body2" sx={{ color: '#8F9BB7' }}>Floor</Typography>
              <Stack direction="row" alignItems="baseline" spacing={0.5}>
                <Chip 
                  label={collection.floorPrice}
                  size="small"
                  sx={{ 
                    bgcolor: 'rgba(255, 46, 99, 0.1)',
                    color: '#FF2E63',
                    border: '1px solid rgba(255, 46, 99, 0.2)'
                  }}
                />
              </Stack>
            </Box>

            <Box>
              <Typography variant="body2" sx={{ color: '#8F9BB7' }}>24h Vol</Typography>
              <Stack direction="row" alignItems="baseline" spacing={0.5}>
                <Chip 
                  label={collection.volume24h}
                  size="small"
                  sx={{ 
                    bgcolor: 'rgba(255, 46, 99, 0.1)',
                    color: '#FF2E63',
                    border: '1px solid rgba(255, 46, 99, 0.2)'
                  }}
                />
              </Stack>
            </Box>

            <Box>
              <Typography variant="body2" sx={{ color: '#8F9BB7' }}>Total Vol</Typography>
              <Stack direction="row" alignItems="baseline" spacing={0.5}>
                <Chip 
                  label={collection.totalVolume}
                  size="small"
                  sx={{ 
                    bgcolor: 'rgba(255, 46, 99, 0.1)',
                    color: '#FF2E63',
                    border: '1px solid rgba(255, 46, 99, 0.2)'
                  }}
                />
              </Stack>
            </Box>

            <Box>
              <Typography variant="body2" sx={{ color: '#8F9BB7' }}>Items</Typography>
              <Typography variant="h6" sx={{ color: '#00F5FF' }}>{collection.supply.toLocaleString()}</Typography>
            </Box>

            <Box>
              <Typography variant="body2" sx={{ color: '#8F9BB7' }}>Owners</Typography>
              <Typography variant="h6" sx={{ color: '#00F5FF' }}>{collection.owners.toLocaleString()}</Typography>
            </Box>

            <Box>
              <Typography variant="body2" sx={{ color: '#8F9BB7' }}>24h %</Typography>
              <Typography 
                variant="h6" 
                sx={{ color: collection.priceChange >= 0 ? '#FFD700' : '#FF2E63' }}
              >
                {collection.priceChange >= 0 ? '+' : ''}{collection.priceChange}%
              </Typography>
            </Box>
          </Stack>
        </Container>
      </Box>

{/* Search by ID */}
<Container maxWidth="xl">
  <Box sx={{ 
    display: 'flex', 
    justifyContent: 'center',
    mt: 4,
    mb: 2
  }}>
    <SearchById collectionId={collectionId} />
  </Box>
</Container>

      {/* NFT Grid */}
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Grid container spacing={3}>
          {sampleNfts.map((nft) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={nft.id}>
              <Link 
                to={`/collection/${collectionId}/item/${nft.id}`}
                style={{ textDecoration: 'none' }}
              >
                <Card 
                  sx={{ 
                    bgcolor: 'rgba(26, 29, 36, 0.5)',
                    backdropFilter: 'blur(20px)',
                    border: '1px solid rgba(0, 245, 255, 0.1)',
                    transition: 'transform 0.2s',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 4px 20px rgba(0, 245, 255, 0.2)'
                    }
                  }}
                >
                  <CardMedia
                    component="img"
                    height="300"
                    image={nft.image}
                    alt={nft.name}
                    sx={{ 
                      objectFit: 'cover',
                      backgroundColor: 'rgba(0, 0, 0, 0.1)'
                    }}
                  />
                  <CardContent>
                    <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                      {nft.name}
                    </Typography>
                    <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 1 }}>
                      <Typography variant="body2" sx={{ color: '#8F9BB7' }}>
                        Price
                      </Typography>
                      <Chip 
                        label={collection.id === "jirasan" || 
                               collection.id === "redacted-remilio-babies" ||
                               collection.id === "bit-bears" ||
                               collection.id === "the-captainz" ||
                               collection.id === "kanpai-pandas" ||
                               collection.id === "sappy-seals" ||
                               collection.id === "infinigods" ||
                               collection.id === "a-kid-called-beast" ||
                               collection.id === "wuv-season-1" ||
                               collection.id === "nakamigos" ||
                               collection.id === "v1-cryptopunks-wrapped" ? 
                               `${nft.price} ETH` : nft.price}
                        size="small"
                        sx={{ 
                          bgcolor: 'rgba(255, 46, 99, 0.1)',
                          color: '#FF2E63',
                          border: '1px solid rgba(255, 46, 99, 0.2)'
                        }}
                      />
                    </Stack>
                  </CardContent>
                </Card>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Container>

      <Footer />
    </Box>
  );
}

export default CollectionPage;
